(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("@hsbc/evolve-runtime", [], factory);
	else if(typeof exports === 'object')
		exports["@hsbc/evolve-runtime"] = factory();
	else
		root["@hsbc/evolve-runtime"] = factory();
})(window, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 7);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CONTEXT_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ACTION_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return MESSAGE_TYPES; });
const CONTEXT_TYPES = {
	APP_METADATA: 'app-metadata'
};

const ACTION_TYPES = {
	OPEN_APP: 'open-app', // no longer in use - here for backward compatability for consumers of this enum
	FOCUS_APP_BY_ID: 'focus-app-by-id',
	CLOSE_APP: 'close-app',
	FLASH: 'flash',
	CREATE_NOTIFICATION: 'create-notification',
	OPEN_SETTINGS: 'open-settings',
	OPEN_SUPPORT: 'open-support',
	OPEN_FEEDBACK: 'open-feedback',
	OPEN_TRAINING: 'open-training',
	TOGGLE_SETTINGS: 'toggle-settings',
	UPDATE_TRAINING_MODULE_STATUS: 'update-training-module-status',
	LOG_USER_EVENT: 'log-user-event'
};

const MESSAGE_TYPES = {
	OPEN_APP: 'open-app',
	APP_FOCUS: 'app-focus',
	APP_BLUR: 'app-blur',
	WORKSPACE_ENTER: 'workspace-enter',
	WORKSPACE_LEAVE: 'workspace-leave',
	GET_TRAINING_MODULES: 'get-training-modules',
	GET_APPS: 'get-apps',
	GET_APP_IS_FOCUSED: 'get-app-is-focused',
	GET_APP_DETAILS: 'get-app-details',
	GET_USER_HAS_ACCESS_TO_APP_BY_ID: 'get-user-has-acces-to-app-by-id',
	GET_USER_HAS_ACCESS_TO_SETTINGS_BY_ID: 'get-user-has-acces-to-settings-by-id',
	GET_USER_HAS_ACCESS_TO_SUPPORT_BY_ID: 'get-user-has-acces-to-support-by-id',
	GET_USER_HAS_ACCESS_TO_TRAINING_BY_ID: 'get-user-has-acces-to-training-by-id',
	STORAGE_REQUEST: 'storage-request',
	INSTANCE_STORAGE_REQUEST: 'instance-storage-request',
	GET_IS_FIRST_EVOLVE_LOAD: 'get-is-first-evolve-load',
	GET_USER_DETAILS: 'get-user-details',
	GET_ENVIRONMENT_DETAILS: 'get-environment-details',
	GET_OPEN_APPS: 'get-open-apps',
	GET_OPEN_APPS_IN_WORKSPACE: 'get-open-apps-in-workspace',
	SET_PLATFORM_DATA: 'set-platform-data',
	RESET_ALL_DATA: 'reset-all-platform-data',
	UPDATE_APP_PIN: 'update-app-pin',
	OPEN_PLATFORM_MENU: 'platform-menu-open',
	CLOSE_PLATFORM_MENU: 'platform-menu-close',
	GET_PLATFORM_STATUS: 'platform-get-status',
	OVERLAY_MODAL_CREATE: 'platform-overlay-modal-create',
	OVERLAY_MODAL_CLOSE: 'platform-overlay-modal-close',
	USER_ACTIVITY: 'app-user-activity',
	RESET_APP_URL: 'reset-app-url'
};

/* unused harmony default export */ var _unused_webpack_default_export = (CONTEXT_TYPES);

/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BODY_MODAL_CSS_CLASS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SUPPRESS_FOCUS_CSS_CLASS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return addModalBodyClass; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return removeModalBodyClass; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return createLocalModal; });
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

// creates a local modal in the app
// this will be done when the app is running in standalone mode,
// or during development when Evolve 2 isn't running

const BODY_MODAL_CSS_CLASS = 'ev-scenario--local-modal-displaying';
const SUPPRESS_FOCUS_CSS_CLASS = 'evolve-runtime-prevent-modal-suppression';

const addModalBodyClass = () => {
	document.body.classList.add(BODY_MODAL_CSS_CLASS);
};

const removeModalBodyClass = () => {
	document.body.classList.remove(BODY_MODAL_CSS_CLASS);
};

const createElement = ({
	domElementId,
	width,
	height,
	minWidth,
	minHeight,
	maxWidth,
	maxHeight,
	closable,
	transparent
}) => {
	const boxElement = document.createElement('section');
	const transparentStyle = transparent ? 'background-color: transparent; box-shadow: none;' : '';
	const constraints = {
		minHeight: minHeight || null,
		minWidth: minWidth || null,
		maxHeight: maxHeight || 'unset',
		maxWidth: maxWidth || 'unset'
	};
	boxElement.innerHTML = `
		<div class="ev-modal" role="alert" aria-live="assertive">
			<div
				class="ev-modal__wrapper"
				role="dialog"
				aria-modal="true"
				style="
					width: ${width};
					height: ${height}; 
					min-height: ${constraints.minHeight};
					min-width: ${constraints.minWidth};
					max-height: ${constraints.maxHeight};
					max-width: ${constraints.maxWidth};
					display: flex; 
					${transparentStyle};
				"
			>
				${typeof closable !== 'boolean' || closable ? `
					<button
						id="modal-close-button"
						class="ev-button ev-button--icon ev-button--borderless"
						aria-label="close"
						title="close"
						type="button"
						auto-focus
					>
						<svg
							focusable="false"
							class="fill"
							xmlns="http://www.w3.org/2000/svg"
							viewBox="0 0 20 20"
						>
							<path d="M15 6.4L13.6 5 10 8.6 6.4 5 5 6.4 8.6 10 5 13.6 6.4 15l3.6-3.6 3.6 3.6 1.4-1.4-3.6-3.6z"></path>
						</svg>
					</button>
				` : ''}
				<section id=${domElementId} style="flex: 1;">
				</section>
			</div>
		</div>
	`;

	boxElement.style.position = 'absolute';
	boxElement.style.top = '0px';
	boxElement.style.right = '0px';
	boxElement.style.bottom = '0px';
	boxElement.style.left = '0px';
	boxElement.style.zIndex = '150000';
	boxElement.style.display = 'block';

	const close = boxElement.querySelector('#modal-close-button');
	if (close) close.addEventListener('click', () => boxElement.remove());

	// place the element into the DOM
	document.body.appendChild(boxElement);

	return {
		close: () => boxElement.remove(),
		getContentElement: () => boxElement.querySelector(`#${domElementId}`)
	};
};

const createLocalModal = opts => {
	if (!opts) throw new Error('expected modal options');
	if (!opts.id) throw new Error('expected a modal ID');
	const domElementId = `element-${opts.id}`;
	const el = createElement(_extends({ domElementId }, opts));
	// we need to implement the same API which otherwise is implemented in runtime.createModal()

	if (!opts.preventFocusSuppression) {
		addModalBodyClass();
	}

	return {
		id: opts.id,
		domElementId: domElementId,
		getContentElement: () => el.getContentElement(),
		close: () => {
			if (!opts.preventFocusSuppression) {
				removeModalBodyClass();
			}
			return el.close();
		}
	};
};

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var R = typeof Reflect === 'object' ? Reflect : null
var ReflectApply = R && typeof R.apply === 'function'
  ? R.apply
  : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
  }

var ReflectOwnKeys
if (R && typeof R.ownKeys === 'function') {
  ReflectOwnKeys = R.ownKeys
} else if (Object.getOwnPropertySymbols) {
  ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target)
      .concat(Object.getOwnPropertySymbols(target));
  };
} else {
  ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
  };
}

function ProcessEmitWarning(warning) {
  if (console && console.warn) console.warn(warning);
}

var NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
  return value !== value;
}

function EventEmitter() {
  EventEmitter.init.call(this);
}
module.exports = EventEmitter;
module.exports.once = once;

// Backwards-compat with node 0.10.x
EventEmitter.EventEmitter = EventEmitter;

EventEmitter.prototype._events = undefined;
EventEmitter.prototype._eventsCount = 0;
EventEmitter.prototype._maxListeners = undefined;

// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var defaultMaxListeners = 10;

function checkListener(listener) {
  if (typeof listener !== 'function') {
    throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
  }
}

Object.defineProperty(EventEmitter, 'defaultMaxListeners', {
  enumerable: true,
  get: function() {
    return defaultMaxListeners;
  },
  set: function(arg) {
    if (typeof arg !== 'number' || arg < 0 || NumberIsNaN(arg)) {
      throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
    }
    defaultMaxListeners = arg;
  }
});

EventEmitter.init = function() {

  if (this._events === undefined ||
      this._events === Object.getPrototypeOf(this)._events) {
    this._events = Object.create(null);
    this._eventsCount = 0;
  }

  this._maxListeners = this._maxListeners || undefined;
};

// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
  if (typeof n !== 'number' || n < 0 || NumberIsNaN(n)) {
    throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
  }
  this._maxListeners = n;
  return this;
};

function _getMaxListeners(that) {
  if (that._maxListeners === undefined)
    return EventEmitter.defaultMaxListeners;
  return that._maxListeners;
}

EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
  return _getMaxListeners(this);
};

EventEmitter.prototype.emit = function emit(type) {
  var args = [];
  for (var i = 1; i < arguments.length; i++) args.push(arguments[i]);
  var doError = (type === 'error');

  var events = this._events;
  if (events !== undefined)
    doError = (doError && events.error === undefined);
  else if (!doError)
    return false;

  // If there is no 'error' event listener then throw.
  if (doError) {
    var er;
    if (args.length > 0)
      er = args[0];
    if (er instanceof Error) {
      // Note: The comments on the `throw` lines are intentional, they show
      // up in Node's output if this results in an unhandled exception.
      throw er; // Unhandled 'error' event
    }
    // At least give some kind of context to the user
    var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
    err.context = er;
    throw err; // Unhandled 'error' event
  }

  var handler = events[type];

  if (handler === undefined)
    return false;

  if (typeof handler === 'function') {
    ReflectApply(handler, this, args);
  } else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i)
      ReflectApply(listeners[i], this, args);
  }

  return true;
};

function _addListener(target, type, listener, prepend) {
  var m;
  var events;
  var existing;

  checkListener(listener);

  events = target._events;
  if (events === undefined) {
    events = target._events = Object.create(null);
    target._eventsCount = 0;
  } else {
    // To avoid recursion in the case that type === "newListener"! Before
    // adding it to the listeners, first emit "newListener".
    if (events.newListener !== undefined) {
      target.emit('newListener', type,
                  listener.listener ? listener.listener : listener);

      // Re-assign `events` because a newListener handler could have caused the
      // this._events to be assigned to a new object
      events = target._events;
    }
    existing = events[type];
  }

  if (existing === undefined) {
    // Optimize the case of one listener. Don't need the extra array object.
    existing = events[type] = listener;
    ++target._eventsCount;
  } else {
    if (typeof existing === 'function') {
      // Adding the second element, need to change to array.
      existing = events[type] =
        prepend ? [listener, existing] : [existing, listener];
      // If we've already got an array, just append.
    } else if (prepend) {
      existing.unshift(listener);
    } else {
      existing.push(listener);
    }

    // Check for listener leak
    m = _getMaxListeners(target);
    if (m > 0 && existing.length > m && !existing.warned) {
      existing.warned = true;
      // No error code for this since it is a Warning
      // eslint-disable-next-line no-restricted-syntax
      var w = new Error('Possible EventEmitter memory leak detected. ' +
                          existing.length + ' ' + String(type) + ' listeners ' +
                          'added. Use emitter.setMaxListeners() to ' +
                          'increase limit');
      w.name = 'MaxListenersExceededWarning';
      w.emitter = target;
      w.type = type;
      w.count = existing.length;
      ProcessEmitWarning(w);
    }
  }

  return target;
}

EventEmitter.prototype.addListener = function addListener(type, listener) {
  return _addListener(this, type, listener, false);
};

EventEmitter.prototype.on = EventEmitter.prototype.addListener;

EventEmitter.prototype.prependListener =
    function prependListener(type, listener) {
      return _addListener(this, type, listener, true);
    };

function onceWrapper() {
  if (!this.fired) {
    this.target.removeListener(this.type, this.wrapFn);
    this.fired = true;
    if (arguments.length === 0)
      return this.listener.call(this.target);
    return this.listener.apply(this.target, arguments);
  }
}

function _onceWrap(target, type, listener) {
  var state = { fired: false, wrapFn: undefined, target: target, type: type, listener: listener };
  var wrapped = onceWrapper.bind(state);
  wrapped.listener = listener;
  state.wrapFn = wrapped;
  return wrapped;
}

EventEmitter.prototype.once = function once(type, listener) {
  checkListener(listener);
  this.on(type, _onceWrap(this, type, listener));
  return this;
};

EventEmitter.prototype.prependOnceListener =
    function prependOnceListener(type, listener) {
      checkListener(listener);
      this.prependListener(type, _onceWrap(this, type, listener));
      return this;
    };

// Emits a 'removeListener' event if and only if the listener was removed.
EventEmitter.prototype.removeListener =
    function removeListener(type, listener) {
      var list, events, position, i, originalListener;

      checkListener(listener);

      events = this._events;
      if (events === undefined)
        return this;

      list = events[type];
      if (list === undefined)
        return this;

      if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0)
          this._events = Object.create(null);
        else {
          delete events[type];
          if (events.removeListener)
            this.emit('removeListener', type, list.listener || listener);
        }
      } else if (typeof list !== 'function') {
        position = -1;

        for (i = list.length - 1; i >= 0; i--) {
          if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
          }
        }

        if (position < 0)
          return this;

        if (position === 0)
          list.shift();
        else {
          spliceOne(list, position);
        }

        if (list.length === 1)
          events[type] = list[0];

        if (events.removeListener !== undefined)
          this.emit('removeListener', type, originalListener || listener);
      }

      return this;
    };

EventEmitter.prototype.off = EventEmitter.prototype.removeListener;

EventEmitter.prototype.removeAllListeners =
    function removeAllListeners(type) {
      var listeners, events, i;

      events = this._events;
      if (events === undefined)
        return this;

      // not listening for removeListener, no need to emit
      if (events.removeListener === undefined) {
        if (arguments.length === 0) {
          this._events = Object.create(null);
          this._eventsCount = 0;
        } else if (events[type] !== undefined) {
          if (--this._eventsCount === 0)
            this._events = Object.create(null);
          else
            delete events[type];
        }
        return this;
      }

      // emit removeListener for all listeners on all events
      if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for (i = 0; i < keys.length; ++i) {
          key = keys[i];
          if (key === 'removeListener') continue;
          this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
      }

      listeners = events[type];

      if (typeof listeners === 'function') {
        this.removeListener(type, listeners);
      } else if (listeners !== undefined) {
        // LIFO order
        for (i = listeners.length - 1; i >= 0; i--) {
          this.removeListener(type, listeners[i]);
        }
      }

      return this;
    };

function _listeners(target, type, unwrap) {
  var events = target._events;

  if (events === undefined)
    return [];

  var evlistener = events[type];
  if (evlistener === undefined)
    return [];

  if (typeof evlistener === 'function')
    return unwrap ? [evlistener.listener || evlistener] : [evlistener];

  return unwrap ?
    unwrapListeners(evlistener) : arrayClone(evlistener, evlistener.length);
}

EventEmitter.prototype.listeners = function listeners(type) {
  return _listeners(this, type, true);
};

EventEmitter.prototype.rawListeners = function rawListeners(type) {
  return _listeners(this, type, false);
};

EventEmitter.listenerCount = function(emitter, type) {
  if (typeof emitter.listenerCount === 'function') {
    return emitter.listenerCount(type);
  } else {
    return listenerCount.call(emitter, type);
  }
};

EventEmitter.prototype.listenerCount = listenerCount;
function listenerCount(type) {
  var events = this._events;

  if (events !== undefined) {
    var evlistener = events[type];

    if (typeof evlistener === 'function') {
      return 1;
    } else if (evlistener !== undefined) {
      return evlistener.length;
    }
  }

  return 0;
}

EventEmitter.prototype.eventNames = function eventNames() {
  return this._eventsCount > 0 ? ReflectOwnKeys(this._events) : [];
};

function arrayClone(arr, n) {
  var copy = new Array(n);
  for (var i = 0; i < n; ++i)
    copy[i] = arr[i];
  return copy;
}

function spliceOne(list, index) {
  for (; index + 1 < list.length; index++)
    list[index] = list[index + 1];
  list.pop();
}

function unwrapListeners(arr) {
  var ret = new Array(arr.length);
  for (var i = 0; i < ret.length; ++i) {
    ret[i] = arr[i].listener || arr[i];
  }
  return ret;
}

function once(emitter, name) {
  return new Promise(function (resolve, reject) {
    function errorListener(err) {
      emitter.removeListener(name, resolver);
      reject(err);
    }

    function resolver() {
      if (typeof emitter.removeListener === 'function') {
        emitter.removeListener('error', errorListener);
      }
      resolve([].slice.call(arguments));
    };

    eventTargetAgnosticAddListener(emitter, name, resolver, { once: true });
    if (name !== 'error') {
      addErrorHandlerIfEventEmitter(emitter, errorListener, { once: true });
    }
  });
}

function addErrorHandlerIfEventEmitter(emitter, handler, flags) {
  if (typeof emitter.on === 'function') {
    eventTargetAgnosticAddListener(emitter, 'error', handler, flags);
  }
}

function eventTargetAgnosticAddListener(emitter, name, listener, flags) {
  if (typeof emitter.on === 'function') {
    if (flags.once) {
      emitter.once(name, listener);
    } else {
      emitter.on(name, listener);
    }
  } else if (typeof emitter.addEventListener === 'function') {
    // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
      // IE does not have builtin `{ once: true }` support so we
      // have to do it manually.
      if (flags.once) {
        emitter.removeEventListener(name, wrapListener);
      }
      listener(arg);
    });
  } else {
    throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
  }
}


/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return REMOTE_STORAGE_METHODS; });
/* harmony import */ var _context_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(0);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }



const REMOTE_STORAGE_METHODS = {
	GET: 'get',
	SET: 'set',
	DELETE: 'delete',
	CLEAR: 'clear'
};

const create = ({ instanceStorage, isLocalhost, hasParent, waitForParentId, messageParent }) => {
	if (typeof instanceStorage !== 'boolean') throw new Error('expected instanceStorage option');
	if (typeof isLocalhost !== 'boolean') throw new Error('expected isLocalhost option');
	if (typeof hasParent !== 'boolean') throw new Error('expected hasParent option');
	if (typeof waitForParentId !== 'function') throw new Error('expected waitForParentId option');
	if (typeof messageParent !== 'function') throw new Error('expected messageParent option');

	const isRunningLocallyWithoutParent = () => isLocalhost && !hasParent;
	const warnAboutLocalUsage = method => {
		if (isRunningLocallyWithoutParent()) console.info(`${method} called while running app locally.  Note that the Discovery Bar must be the parent app in order to get a reply, or you can mock this method.`);
	};

	const namespace = instanceStorage ? 'instanceStorage' : 'storage';

	// our remote storage api that communicates with the discovery bar in order persist things
	const sendRequest = opts => {
		// sends a request to to the Discovery Bar for storage interaction
		if (!hasParent) return Promise.reject('Window is running standalone without the Discovery Bar');
		if (!opts) throw new Error('Expected an options argument');
		if (!opts.method || typeof opts.method !== 'string') throw new Error('Expected a method');
		// include additional params
		const rest = typeof opts.rest === 'object' ? opts.rest : {};
		const MESSAGE = instanceStorage ? _context_types__WEBPACK_IMPORTED_MODULE_0__[/* MESSAGE_TYPES */ "c"].INSTANCE_STORAGE_REQUEST : _context_types__WEBPACK_IMPORTED_MODULE_0__[/* MESSAGE_TYPES */ "c"].STORAGE_REQUEST;
		return new Promise((() => {
			var _ref = _asyncToGenerator(function* (resolve, reject) {
				try {
					const parentId = yield waitForParentId();
					messageParent(MESSAGE, _extends({}, rest, { // always before, so we have complete control over following values
						method: opts.method,
						key: opts.key,
						value: opts.value,
						appId: opts.appId,
						parentId: parentId
					})).onReply(function (message) {
						const { success, payload } = message.data;
						if (success) {
							resolve(payload);
						} else {
							reject(payload);
						}
					});
				} catch (e) {
					reject(e);
				}
			});

			return function (_x, _x2) {
				return _ref.apply(this, arguments);
			};
		})());
	};
	const getOptionalString = (key, options) => {
		return options && options[key] && typeof options[key] === 'string' ? options[key] : null;
	};
	const getMockLocalKey = (key, appId) => `runtime.dev-storage-mock.${appId || 'app'}.${key}`;
	const storageWarn = (method, key) => console.info(`runtime.${namespace}.${method} called while running app locally without the Discovery Bar.  Mocking storage locally, using storage key ${key}.`);
	return {
		// gets a specifc app item from users remote storage
		// key (string) - required - the storage key of the value that you want to get
		get: (() => {
			var _ref2 = _asyncToGenerator(function* (key, opts) {
				warnAboutLocalUsage(`${namespace}.get()`);
				if (!key || typeof key !== 'string') throw new Error('Expected a key');
				const appId = getOptionalString('appId', opts);

				// if app is running locally without discovery bar, mock out using local storage
				if (isRunningLocallyWithoutParent()) {
					const mockKey = getMockLocalKey(key, appId);
					storageWarn('get()', mockKey);
					const result = JSON.parse(localStorage.getItem(mockKey));
					return Promise.resolve(result);
				}
				return sendRequest({ method: REMOTE_STORAGE_METHODS.GET, appId, key, rest: opts });
			});

			return function get(_x3, _x4) {
				return _ref2.apply(this, arguments);
			};
		})(),

		// sets a specifc key / value combination to users remote storage
		// key (string) - required - the storage key to set the value against
		// value (any) - required - the value you want to store
		set: (() => {
			var _ref3 = _asyncToGenerator(function* (key, value, opts) {
				warnAboutLocalUsage(`${namespace}.set()`);
				if (!key || typeof key !== 'string') throw new Error('Expected a key');
				const appId = getOptionalString('appId', opts);

				// if app is running locally without discovery bar, mock out using local storage
				if (isRunningLocallyWithoutParent()) {
					const mockKey = getMockLocalKey(key, appId);
					storageWarn('set()', mockKey);
					const result = localStorage.setItem(mockKey, JSON.stringify(value));
					return Promise.resolve(result);
				}
				return sendRequest({
					method: REMOTE_STORAGE_METHODS.SET,
					appId,
					key,
					value,
					rest: opts
				});
			});

			return function set(_x5, _x6, _x7) {
				return _ref3.apply(this, arguments);
			};
		})(),

		// deletes a specifc key from users remote storage
		// key (string) - required - the storage key of the value you want to delete
		delete: (() => {
			var _ref4 = _asyncToGenerator(function* (key, opts) {
				warnAboutLocalUsage(`${namespace}.delete()`);
				if (!key || typeof key !== 'string') throw new Error('Expected a key');
				const appId = getOptionalString('appId', opts);

				// if app is running locally without discovery bar, mock out using local storage
				if (isRunningLocallyWithoutParent()) {
					const mockKey = getMockLocalKey(key, appId);
					storageWarn('delete()', mockKey);
					localStorage.removeItem(mockKey);
					return Promise.resolve();
				}
				return sendRequest({ method: REMOTE_STORAGE_METHODS.DELETE, appId, key, rest: opts });
			});

			return function _delete(_x8, _x9) {
				return _ref4.apply(this, arguments);
			};
		})(),

		// deletes all of the apps data from users remote storage
		// opts (object) - optional - allows you specify the scope (appId) to clear
		clear: (() => {
			var _ref5 = _asyncToGenerator(function* (opts) {
				warnAboutLocalUsage(`${namespace}.clear()`);
				if (isRunningLocallyWithoutParent()) {
					return Promise.resolve();
				}
				return sendRequest({
					method: REMOTE_STORAGE_METHODS.CLEAR,
					appId: getOptionalString('appId', opts),
					rest: opts
				});
			});

			return function clear(_x10) {
				return _ref5.apply(this, arguments);
			};
		})()
	};
};

/* harmony default export */ __webpack_exports__["b"] = (create);

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// a list of public events which consumers can listen or publish

/* harmony default export */ __webpack_exports__["a"] = ({
	OTHER_APP_CLOSED: 'OTHER_APP_CLOSED'
});

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export debounce */
const debounce = (func, delay) => {
	let debounceTimer;
	return [function bind() {
		const context = this;
		const args = arguments;
		clearTimeout(debounceTimer);
		debounceTimer = setTimeout(() => func.apply(context, args), delay);
	}, function unbind() {
		clearTimeout(debounceTimer);
	}];
};

/* harmony default export */ __webpack_exports__["a"] = (debounce);

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/* harmony import */ var events__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var events__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(events__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _context_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(0);
/* harmony import */ var _communication_public_events_enum__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(4);
/* harmony import */ var _remote_storage___WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3);
/* harmony import */ var _runtime_ui_modal__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1);
/* harmony import */ var _utils_debounce__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }








const DOCS_URL = 'https://apprunner.hk.hsbc/evolve-base-assets/documentation/evolve-runtime.html';
const EVOLVE_DOCS_URL = 'https://gbmt-confluence.prd.fx.gbm.cloud.uk.hsbc/x/855hJg';

const eventBus = new events__WEBPACK_IMPORTED_MODULE_0__["EventEmitter"]();

const getParentInfo = runtime => {
	const HANDSHAKE_TIMEOUT = 5000;
	const HANDSHAKE_REQUEST = 'HANDSHAKE_REQUEST';
	const HANDSHAKE_REPLY = 'HANDSHAKE_REPLY';

	// an array of listener function(s) to be invoked once we know we have a parent
	const listeners = [];

	let handshakeTimeoutId = null;
	let handshakeTimedOut = false;
	let parentId = null;

	const addListener = ({ onHasParentId, onTimeout }) => {
		listeners.push({ onHasParentId, onTimeout });
	};

	const invokeListeners = ({ success }) => {
		handshakeTimedOut = !success; // store if there has been a timeout or not
		clearTimeout(handshakeTimeoutId); // clear the timeout handler
		listeners.forEach(i => {
			try {
				if (success) {
					i.onHasParentId(parentId);
				} else {
					i.onTimeout('timeout getting parent id');
				}
			} catch (e) {
				window.console.log(e);
			}
		});
		listeners.length = 0;
	};

	// set a timer which allows 5 seconds to establish the parent id
	handshakeTimeoutId = setTimeout(() => invokeListeners({ success: false }), HANDSHAKE_TIMEOUT);

	// on handshake reply form parent, store their info
	const unbind = runtime.onParentMessage(HANDSHAKE_REPLY, data => {
		parentId = data.sourceId;
		unbind();
		invokeListeners({ success: true });
	});

	// reply back to any handshake requests from our children
	runtime.onChildMessage(HANDSHAKE_REQUEST, data => {
		if (!data.source) return;
		runtime.messageChild(data.source, HANDSHAKE_REPLY, { version: 1 });
	});

	// finally message parent (if there is one)
	runtime.messageParent(HANDSHAKE_REQUEST, { version: 1 });

	return {
		waitForParentId: () => {
			if (parentId) return Promise.resolve(parentId);
			if (!runtime.getParent()) return Promise.reject('no parent');
			if (handshakeTimedOut) return Promise.reject('timed out getting parent id');
			return new Promise((resolve, reject) => {
				addListener({
					onHasParentId: () => resolve(parentId),
					onTimeout: e => reject(e)
				});
			});
		},
		getParentId: () => parentId
	};
};

// informs discovery bar whenever we update the url
const listenForUrlChanges = runtime => {
	let disabled = false;
	const sendUpdate = () => {
		const location = window.location;
		const url = location.href.toString().replace(location.origin, '');
		if (!disabled) runtime.updateAppMetadata({ url });
	};
	const override = name => {
		if (history && typeof history[name] === 'function') {
			const original = history[name];
			history[name] = (state, title, url, ...args) => {
				const hrefBefore = location.href.toString();
				const val = original.call(history, state, title, url, ...args);
				const hrefAfter = location.href.toString();
				const hrefHasChanged = hrefBefore !== hrefAfter;
				try {
					if (typeof url === 'string' && hrefHasChanged) sendUpdate();
				} catch (e) {
					console.error(e);
				}
				return val;
			};
		}
	};
	override('replaceState');
	override('pushState');
	window.addEventListener('hashchange', sendUpdate, false);

	runtime.disableUrlPersistence = () => disabled = true;
	runtime.enableUrlPersistence = () => {
		disabled = false;
		sendUpdate();
	};
};

const setupActivityBroadcasting = ({ runtime, parent, rootInstanceId }) => {
	const [handler, cancelPending] = Object(_utils_debounce__WEBPACK_IMPORTED_MODULE_5__[/* default */ "a"])(() => {
		runtime.messageTopParent(_context_types__WEBPACK_IMPORTED_MODULE_1__[/* MESSAGE_TYPES */ "c"].USER_ACTIVITY, {
			parentId: parent.getParentId(),
			instanceId: rootInstanceId
		});
	}, 200);

	const options = { capture: false, passive: true };
	window.addEventListener('click', handler, options);
	window.addEventListener('focus', handler, options);

	runtime.onAppClose(() => {
		window.removeEventListener('click', handler, options);
		window.removeEventListener('focus', handler, options);
		cancelPending();
	});
};

const setup = ({
	runtime, // the evolve runtime api
	rootInstanceId, // the instance id of the runtime
	isRootInstance // is the current instance the root
}) => {
	const ROOT_INSTANCE_ID = rootInstanceId;
	const IS_ROOT_INSTANCE = isRootInstance;

	// run only in local, and in browser (this is not perfect, but it doesn't need to be.)
	if (runtime.isLocalhost() && typeof window !== 'undefined' && typeof process === 'undefined') {
		console.group(`Evolve Runtime v${runtime.version}`);
		console.log(`Check out the Evolve Runtime Docs at ${DOCS_URL}`);
		console.log(`Check out the Evolve 2.0 Docs at ${EVOLVE_DOCS_URL}`);
		console.log(`These messages only show when running locally.`);
		console.groupEnd();
	}

	const isRunningLocallyWithoutParent = () => runtime.isLocalhost() && !runtime.getParent();
	const warnAboutLocalUsage = method => {
		if (isRunningLocallyWithoutParent()) console.info(`${method} called while running app locally.  Note that the Discovery Bar must be the parent app in order to get a reply, or you can mock this method.`);
	};
	const throwErrorIfNoParent = method => {
		if (!runtime.isLocalhost() && !runtime.getParent()) throw new Error(`App is running standalone - runtime.${method} will not work`);
	};

	const parent = getParentInfo(runtime);

	// use our context capability to allow apps to simply set app context data
	const contextApi = runtime.connect();

	contextApi.providesContextType({ type: _context_types__WEBPACK_IMPORTED_MODULE_1__[/* CONTEXT_TYPES */ "b"].APP_METADATA, version: 1 });

	runtime.updateAppMetadata = data => {
		if (!runtime.isStandAloneWindow() && runtime.isInStaticWorkspace()) return;
		if (!data || typeof data !== 'object') return;
		contextApi.setContext({
			type: _context_types__WEBPACK_IMPORTED_MODULE_1__[/* CONTEXT_TYPES */ "b"].APP_METADATA,
			version: 1,
			data
		});
	};

	// informs the discovery bar whenver url changes have been made
	listenForUrlChanges(runtime);

	// use our context capability to allow others to request the app to flash
	contextApi.performsActionType({ type: _context_types__WEBPACK_IMPORTED_MODULE_1__[/* ACTION_TYPES */ "a"].FLASH, version: 1 });
	contextApi.onActionRequested(action => {
		if (action.type === _context_types__WEBPACK_IMPORTED_MODULE_1__[/* ACTION_TYPES */ "a"].FLASH) {
			runtime.flash();
			if (!action.permanent) {
				setTimeout(() => {
					runtime.stopFlash();
				}, 3000);
			}
		}
	});

	// use our context capability to focus specific apps
	// focus by unique id						focusAppById({ id: 'execution-abc-123-q-asd' });
	// focus an app with generuc id  			focusAppById({ id: 'execution });
	runtime.focusAppById = data => {
		const getDebugString = prefix => `${prefix} - Consult the runtime docs ${DOCS_URL}#section_OpeningApps`;
		if (!data || typeof data !== 'object') throw new Error(getDebugString('No options provided'));
		if (typeof data.id !== 'string') throw new Error(getDebugString('No app ID provided'));
		contextApi.requestAction({
			type: _context_types__WEBPACK_IMPORTED_MODULE_1__[/* ACTION_TYPES */ "a"].FOCUS_APP_BY_ID,
			version: 1,
			data: _extends({}, data, {
				parentId: parent.getParentId(),
				instanceId: ROOT_INSTANCE_ID
			})
		});
	};

	runtime.closeApp = data => {
		if (data && typeof data.id !== 'string') {
			const getDebugString = prefix => `${prefix} - Consult the runtime docs ${DOCS_URL}#section_OpeningApps`;
			throw new Error(getDebugString('No id provided'));
		}
		contextApi.requestAction({
			type: _context_types__WEBPACK_IMPORTED_MODULE_1__[/* ACTION_TYPES */ "a"].CLOSE_APP,
			version: 1,
			data: _extends({}, typeof data === 'object' ? data : {}, {
				parentId: parent.getParentId(),
				instanceId: ROOT_INSTANCE_ID
			})
		});
	};

	runtime.createNotification = data => {
		const getDebugString = prefix => `${prefix} - Consult the runtime docs ${DOCS_URL}#section_Notifications`;
		if (!data || typeof data !== 'object') {
			throw new Error(getDebugString('No notifications payload provided'));
		}
		if (typeof data.title !== 'string') {
			throw new Error(getDebugString('Notification "title" must be provided and be a string'));
		}
		if (typeof data.body !== 'string') {
			throw new Error(getDebugString('Notification "body" must be provided and be a string'));
		}
		if (data.refId && typeof data.refId !== 'string') {
			throw new Error(getDebugString('Notification "refId" must be a string, when provided'));
		}
		if (data.appParams && typeof data.appParams !== 'object') {
			throw new Error(getDebugString('Notification "appParams" must be an object, when provided'));
		}
		if (data.startTime && typeof data.startTime !== 'number') {
			throw new Error(getDebugString('Notification "startTime" must be a number, when provided'));
		}
		if (data.expireTime && typeof data.expireTime !== 'number') {
			throw new Error(getDebugString('Notification "expireTime" must be a number, when provided'));
		}
		contextApi.requestAction({
			type: _context_types__WEBPACK_IMPORTED_MODULE_1__[/* ACTION_TYPES */ "a"].CREATE_NOTIFICATION,
			version: 1,
			data: {
				parentId: parent.getParentId(),
				instanceId: ROOT_INSTANCE_ID,
				notification: data
			}
		});
	};

	runtime.logUserEvent = args => {
		const getDebugString = prefix => `${prefix} - Consult the runtime docs ${DOCS_URL}#section_UserEventLogging`;

		if (!args) throw new Error(getDebugString('"logUserEvent()" requires arguments'));

		const getName = () => {
			if (typeof args === 'string') return args;
			if (args.name && typeof args.name !== 'string') {
				throw new Error(getDebugString('"name" must be a string, when provided'));
			}
			return args.name || null;
		};
		const getAppId = () => {
			if (typeof args === 'string') return null;
			if (args.appId && typeof args.appId !== 'string') {
				throw new Error(getDebugString('"appId" must be a string, when provided'));
			}
			return args.appId || null;
		};
		const getDataPayload = () => {
			if (typeof args === 'string') return null;
			return args.data || null;
		};

		contextApi.requestAction({
			type: _context_types__WEBPACK_IMPORTED_MODULE_1__[/* ACTION_TYPES */ "a"].LOG_USER_EVENT,
			version: 1,
			data: {
				parentId: parent.getParentId(),
				instanceId: ROOT_INSTANCE_ID,
				event: {
					name: getName(),
					appId: getAppId(),
					data: getDataPayload()
				}
			}
		});
	};

	// opens general or specific settings by id
	runtime.openSettings = data => {
		const getDebugString = prefix => `${prefix} - Consult the runtime docs ${DOCS_URL}#open-settings`;
		if (data && typeof data.id !== 'string') throw new Error(getDebugString('No settings ID provided in options'));
		contextApi.requestAction({
			type: _context_types__WEBPACK_IMPORTED_MODULE_1__[/* ACTION_TYPES */ "a"].OPEN_SETTINGS,
			version: 1,
			data: _extends({}, data || {}, {
				parentId: parent.getParentId(),
				instanceId: ROOT_INSTANCE_ID
			})
		});
		runtime.focusDiscoveryBarWindow();
	};

	// toggles general or specific settings by id
	runtime.toggleSettings = data => {
		const getDebugString = prefix => `${prefix} - Consult the runtime docs ${DOCS_URL}#toggle-settings`;
		if (data && typeof data.id !== 'string') throw new Error(getDebugString('No settings ID provided in options'));
		contextApi.requestAction({
			type: _context_types__WEBPACK_IMPORTED_MODULE_1__[/* ACTION_TYPES */ "a"].TOGGLE_SETTINGS,
			version: 1,
			data: _extends({}, data || {}, {
				parentId: parent.getParentId(),
				instanceId: ROOT_INSTANCE_ID
			})
		});
		runtime.focusDiscoveryBarWindow();
	};

	// opens a support section by id
	runtime.openSupport = data => {
		const getDebugString = prefix => `${prefix} - Consult the runtime docs ${DOCS_URL}#open-support`;
		if (data && typeof data.id !== 'string') throw new Error(getDebugString('No support ID provided in options'));
		contextApi.requestAction({
			type: _context_types__WEBPACK_IMPORTED_MODULE_1__[/* ACTION_TYPES */ "a"].OPEN_SUPPORT,
			version: 1,
			data: _extends({}, data || {}, {
				parentId: parent.getParentId(),
				instanceId: ROOT_INSTANCE_ID
			})
		});
		runtime.focusDiscoveryBarWindow();
	};

	// opens a training section by id
	runtime.openTraining = data => {
		const getDebugString = prefix => `${prefix} - Consult the runtime docs ${DOCS_URL}#open-training`;
		if (data && typeof data.id !== 'string') throw new Error(getDebugString('No training ID provided in options'));
		contextApi.requestAction({
			type: _context_types__WEBPACK_IMPORTED_MODULE_1__[/* ACTION_TYPES */ "a"].OPEN_TRAINING,
			version: 1,
			data: _extends({}, data || {}, {
				parentId: parent.getParentId(),
				instanceId: ROOT_INSTANCE_ID
			})
		});
	};

	// opens feedback section
	runtime.openFeedback = () => {
		contextApi.requestAction({
			type: _context_types__WEBPACK_IMPORTED_MODULE_1__[/* ACTION_TYPES */ "a"].OPEN_FEEDBACK,
			version: 1,
			data: {
				parentId: parent.getParentId(),
				instanceId: ROOT_INSTANCE_ID
			}
		});
		runtime.focusDiscoveryBarWindow();
	};

	// add utility methods for when we enter and leave a workspace
	const getWorkspaceContext = () => {
		if (!runtime.isInWorkspace()) throw new Error('App is not in a workspace');
		if (!runtime.getWorkspaceId()) throw new Error('No workspace ID has been provided');
		return runtime.connect({ scope: runtime.getWorkspaceId() });
	};
	const setupWorkspaceLifecycleHandlers = context => {
		runtime.updateBodyElementClasses();

		eventBus.once(_context_types__WEBPACK_IMPORTED_MODULE_1__[/* MESSAGE_TYPES */ "c"].WORKSPACE_LEAVE, () => {
			context.disconnect(); // disconect on leave
			runtime.updateBodyElementClasses();
		});
	};

	// ensure app disconnects from workspace context on leave
	// and take into account if the app has loaded inside the workspace
	if (runtime.isInWorkspace()) setupWorkspaceLifecycleHandlers(getWorkspaceContext());
	eventBus.on(_context_types__WEBPACK_IMPORTED_MODULE_1__[/* MESSAGE_TYPES */ "c"].WORKSPACE_ENTER, () => setupWorkspaceLifecycleHandlers(getWorkspaceContext()));
	runtime.onEnterWorkspace = (fn, opts) => {
		// invoke the handler if app is already in a workspace and the option has been set
		if (opts && opts.invokeIfAlreadyInWorkspace && runtime.isInWorkspace()) fn();
		eventBus.on(_context_types__WEBPACK_IMPORTED_MODULE_1__[/* MESSAGE_TYPES */ "c"].WORKSPACE_ENTER, fn);
		return () => eventBus.off(_context_types__WEBPACK_IMPORTED_MODULE_1__[/* MESSAGE_TYPES */ "c"].WORKSPACE_ENTER, fn);
	};
	runtime.onLeaveWorkspace = fn => {
		eventBus.on(_context_types__WEBPACK_IMPORTED_MODULE_1__[/* MESSAGE_TYPES */ "c"].WORKSPACE_LEAVE, fn);
		return () => eventBus.off(_context_types__WEBPACK_IMPORTED_MODULE_1__[/* MESSAGE_TYPES */ "c"].WORKSPACE_LEAVE, fn);
	};
	runtime.getWorkspaceContext = getWorkspaceContext;
	runtime.onMessage(_communication_public_events_enum__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].OTHER_APP_CLOSED, data => {
		// iframes can be closed before they emit the change event
		// so this message is emitted by the discovery bar once an app has been closed, also
		if (!runtime.isInWorkspace()) return;
		if (!data || typeof data.id !== 'string') return;
		const api = getWorkspaceContext();
		api.informExternalAppClose(data.id);
	});

	// listens out for direct messages and then delegates to our event bus
	contextApi.onDirectMessage(message => {
		if (message.data.subject === _context_types__WEBPACK_IMPORTED_MODULE_1__[/* MESSAGE_TYPES */ "c"].WORKSPACE_ENTER) {
			eventBus.emit(_context_types__WEBPACK_IMPORTED_MODULE_1__[/* MESSAGE_TYPES */ "c"].WORKSPACE_ENTER, message.data);
		} else if (message.data.subject === _context_types__WEBPACK_IMPORTED_MODULE_1__[/* MESSAGE_TYPES */ "c"].WORKSPACE_LEAVE) {
			eventBus.emit(_context_types__WEBPACK_IMPORTED_MODULE_1__[/* MESSAGE_TYPES */ "c"].WORKSPACE_LEAVE, message.data);
		} else if (message.data.subject === _context_types__WEBPACK_IMPORTED_MODULE_1__[/* MESSAGE_TYPES */ "c"].APP_FOCUS) {
			eventBus.emit(_context_types__WEBPACK_IMPORTED_MODULE_1__[/* MESSAGE_TYPES */ "c"].APP_FOCUS, message.data);
		} else if (message.data.subject === _context_types__WEBPACK_IMPORTED_MODULE_1__[/* MESSAGE_TYPES */ "c"].APP_BLUR) {
			eventBus.emit(_context_types__WEBPACK_IMPORTED_MODULE_1__[/* MESSAGE_TYPES */ "c"].APP_BLUR, message.data);
		}
	});

	// returns a promise which resolves once the platform data is set
	// only background apps which have appropritae permissions can call this method
	// note that the Discovery Bar must be the parent app in order to get a reply
	// if you are running in localhost and expect a reply, then you'll need to mock this out
	runtime.setPlatformData = data => new Promise((resolve, reject) => {
		warnAboutLocalUsage(`setPlatformData()`);
		try {
			if (typeof data !== 'object') throw new Error('Data object must be provided');
			if (data.language && typeof data.language !== 'string') throw new Error('language option must be a string');
			if (data.dateFormat && typeof data.dateFormat !== 'string') throw new Error('dateFormat option must be a string');
			throwErrorIfNoParent('setPlatformData()');
			runtime.messageTopParent(_context_types__WEBPACK_IMPORTED_MODULE_1__[/* MESSAGE_TYPES */ "c"].SET_PLATFORM_DATA, data).onReply(message => {
				if (message.data.error) {
					throw new Error(message.data.error);
				}
				resolve();
			});
		} catch (e) {
			reject(e);
		}
	});

	// returns a promise which resolves once the platform data has been reset
	// CALLING THIS WILL RESET ALL A USERS APP AND PLATFORM DATA
	// only background apps which have appropritae permissions can call this method
	// note that the Discovery Bar must be the parent app in order to get a reply
	// if you are running in localhost and expect a reply, then you'll need to mock this out
	runtime.resetAllPlatformData = () => new Promise((resolve, reject) => {
		warnAboutLocalUsage(`resetAllPlatformData()`);
		try {
			throwErrorIfNoParent('resetAllPlatformData()');
			runtime.messageTopParent(_context_types__WEBPACK_IMPORTED_MODULE_1__[/* MESSAGE_TYPES */ "c"].RESET_ALL_DATA).onReply(message => {
				if (message.data.error) {
					throw new Error(message.data.error);
				}
				resolve();
			});
		} catch (e) {
			reject(e);
		}
	});

	// returns a promise which resolves to an array of available application IDs and names
	// note that the Discovery Bar must be the parent app in order to get a reply
	// if you are running in localhost and expect a reply, then you'll need to mock this out
	runtime.getApps = () => new Promise((resolve, reject) => {
		warnAboutLocalUsage(`getApps()`);
		try {
			throwErrorIfNoParent('getApps()');
			runtime.messageTopParent(_context_types__WEBPACK_IMPORTED_MODULE_1__[/* MESSAGE_TYPES */ "c"].GET_APPS).onReply(message => {
				resolve(message.data);
			});
		} catch (e) {
			reject(e);
		}
	});

	// returns a promise which resolves to an boolean indicating if this is the first time that the user
	// has loaded Evolve 2.0.
	// once the user has used Evolve 2.0 more than once, this will always resolve as false false
	// if you are running in localhost and expect a reply, then you'll need to mock this out
	runtime.getIsFirstEvolveLoad = () => new Promise((resolve, reject) => {
		warnAboutLocalUsage(`getIsFirstEvolveLoad()`);
		try {
			throwErrorIfNoParent('getIsFirstEvolveLoad()');
			runtime.messageTopParent(_context_types__WEBPACK_IMPORTED_MODULE_1__[/* MESSAGE_TYPES */ "c"].GET_IS_FIRST_EVOLVE_LOAD).onReply(message => {
				resolve(message.data);
			});
		} catch (e) {
			reject(e);
		}
	});

	// returns a promise which resolves a boolean that indicates if the user has access to
	// a specific workspace or app by it's particular id
	// note that the Discovery Bar must be the parent app in order to get a reply
	// if you are running in localhost and expect a reply, then you'll need to mock this out
	runtime.getUserHasAccessToAppById = id => new Promise((resolve, reject) => {
		warnAboutLocalUsage(`getUserHasAccessToAppById()`);
		try {
			if (typeof id !== 'string') throw new Error('App Id must be a string');
			throwErrorIfNoParent('getUserHasAccessToAppById()');
			runtime.messageTopParent(_context_types__WEBPACK_IMPORTED_MODULE_1__[/* MESSAGE_TYPES */ "c"].GET_USER_HAS_ACCESS_TO_APP_BY_ID, { id: id }).onReply(message => {
				resolve(message.data);
			});
		} catch (e) {
			reject(e);
		}
	});

	// update pin of current app		updateAppPin({ pin: true });
	// update pin of another app		updateAppPin({ id: 'execution', pin: true });
	runtime.updateAppPin = data => {
		return new Promise((resolve, reject) => {
			if (!data || typeof data !== 'object') throw new Error('No options provided');
			if (typeof data.pin !== 'boolean') throw new Error('No pin flag provided');
			warnAboutLocalUsage(`updateAppPin()`);
			try {
				runtime.messageTopParent(_context_types__WEBPACK_IMPORTED_MODULE_1__[/* MESSAGE_TYPES */ "c"].UPDATE_APP_PIN, _extends({}, data, {
					parentId: parent.getParentId()
				})).onReply(message => {
					resolve(message.data);
				});
			} catch (e) {
				reject(e);
			}
		});
	};

	// returns a promise which resolves a boolean that indicates if the user has access to
	// specific settings section
	// note that the Discovery Bar must be the parent app in order to get a reply
	// if you are running in localhost and expect a reply, then you'll need to mock this out
	runtime.getUserHasAccessToSettingsById = id => new Promise((resolve, reject) => {
		warnAboutLocalUsage(`getUserHasAccessToSettingsById()`);
		try {
			if (typeof id !== 'string') throw new Error('Settings Id must be a string');
			throwErrorIfNoParent('getUserHasAccessToSettingsById()');
			runtime.messageTopParent(_context_types__WEBPACK_IMPORTED_MODULE_1__[/* MESSAGE_TYPES */ "c"].GET_USER_HAS_ACCESS_TO_SETTINGS_BY_ID, {
				id: id
			}).onReply(message => {
				resolve(message.data);
			});
		} catch (e) {
			reject(e);
		}
	});

	// returns a promise which resolves a boolean that indicates if the user has access to
	// specific help and support section
	// note that the Discovery Bar must be the parent app in order to get a reply
	// if you are running in localhost and expect a reply, then you'll need to mock this out
	runtime.getUserHasAccessToSupportById = id => new Promise((resolve, reject) => {
		warnAboutLocalUsage(`getUserHasAccessToSupportById()`);
		try {
			if (typeof id !== 'string') throw new Error('Help / Support Id must be a string');
			throwErrorIfNoParent('getUserHasAccessToSupportById()');
			runtime.messageTopParent(_context_types__WEBPACK_IMPORTED_MODULE_1__[/* MESSAGE_TYPES */ "c"].GET_USER_HAS_ACCESS_TO_SUPPORT_BY_ID, {
				id: id
			}).onReply(message => {
				resolve(message.data);
			});
		} catch (e) {
			reject(e);
		}
	});

	// returns a promise which resolves to an array of available training module IDs and names
	// note that the Discovery Bar must be the parent app in order to get a reply
	// if you are running in localhost and expect a reply, then you'll need to mock this out
	runtime.getTrainingModules = () => new Promise((resolve, reject) => {
		warnAboutLocalUsage(`getTrainingModules()`);
		try {
			throwErrorIfNoParent('getTrainingModules()');
			runtime.messageTopParent(_context_types__WEBPACK_IMPORTED_MODULE_1__[/* MESSAGE_TYPES */ "c"].GET_TRAINING_MODULES).onReply(message => {
				if (!message.data) {
					throw new Error('No training modules available - Discovery Bar service issue');
				}
				resolve(message.data);
			});
		} catch (e) {
			reject(e);
		}
	});

	// returns a promise which resolves to details of a particular training module
	// note that the Discovery Bar must be the parent app in order to get a reply
	// if you are running in localhost and expect a reply, then you'll need to mock this out
	runtime.getTrainingModuleById = (() => {
		var _ref = _asyncToGenerator(function* (id) {
			warnAboutLocalUsage(`getTrainingModuleById()`);
			const modules = yield runtime.getTrainingModules();
			return modules.find(function (i) {
				return i.id === id;
			}) || null;
		});

		return function (_x) {
			return _ref.apply(this, arguments);
		};
	})();

	// returns a promise which resolves a boolean that indicates if the user has access to
	// specific training module by it's ID
	// note that the Discovery Bar must be the parent app in order to get a reply
	// if you are running in localhost and expect a reply, then you'll need to mock this out
	runtime.getUserHasAccessToTrainingById = id => new Promise((resolve, reject) => {
		warnAboutLocalUsage(`getUserHasAccessToTrainingById()`);
		try {
			if (typeof id !== 'string') throw new Error('Training Module Id must be a string');
			throwErrorIfNoParent('getUserHasAccessToTrainingById()');
			runtime.messageTopParent(_context_types__WEBPACK_IMPORTED_MODULE_1__[/* MESSAGE_TYPES */ "c"].GET_USER_HAS_ACCESS_TO_TRAINING_BY_ID, {
				id: id
			}).onReply(message => {
				resolve(message.data);
			});
		} catch (e) {
			reject(e);
		}
	});

	// returns a promise which resolves the user details
	// note that the Discovery Bar must be the parent app in order to get a reply
	// if you are running in localhost and expect a reply, then you'll need to mock this out
	runtime.getUserDetails = () => new Promise((resolve, reject) => {
		warnAboutLocalUsage(`getUserDetails()`);
		try {
			throwErrorIfNoParent('getUserDetails()');
			runtime.messageTopParent(_context_types__WEBPACK_IMPORTED_MODULE_1__[/* MESSAGE_TYPES */ "c"].GET_USER_DETAILS).onReply(message => {
				resolve(message.data);
			});
		} catch (e) {
			reject(e);
		}
	});

	// returns a promise which resolves the current environment details
	// note that the Discovery Bar must be the parent app in order to get a reply
	// if you are running in localhost and expect a reply, then you'll need to mock this out
	runtime.getEnvironmentDetails = () => new Promise((resolve, reject) => {
		warnAboutLocalUsage(`getEnvironmentDetails()`);
		try {
			throwErrorIfNoParent('getEnvironmentDetails()');
			runtime.messageTopParent(_context_types__WEBPACK_IMPORTED_MODULE_1__[/* MESSAGE_TYPES */ "c"].GET_ENVIRONMENT_DETAILS).onReply(message => {
				resolve(message.data);
			});
		} catch (e) {
			reject(e);
		}
	});

	// returns a promise which resolves information about all of the current open apps and workspaces
	// note that the Discovery Bar must be the parent app in order to get a reply
	// if you are running in localhost and expect a reply, then you'll need to mock this out
	runtime.getOpenApps = () => new Promise((resolve, reject) => {
		warnAboutLocalUsage(`getOpenApps()`);
		try {
			throwErrorIfNoParent('getOpenApps()');
			runtime.messageTopParent(_context_types__WEBPACK_IMPORTED_MODULE_1__[/* MESSAGE_TYPES */ "c"].GET_OPEN_APPS).onReply(message => {
				resolve(message.data);
			});
		} catch (e) {
			reject(e);
		}
	});

	// returns a promise which resolves information about whether an app is open
	// note that the Discovery Bar must be the parent app in order to get a reply
	// if you are running in localhost and expect a reply, then you'll need to mock this out
	runtime.getAppIsOpenById = id => new Promise((() => {
		var _ref2 = _asyncToGenerator(function* (resolve, reject) {
			warnAboutLocalUsage(`getAppIsOpenById()`);
			try {
				if (typeof id !== 'string') throw new Error('Expected an id (string) to be passed into runtime.getAppIsOpenById()');
				throwErrorIfNoParent('getAppIsOpenById()');
				const apps = yield runtime.getOpenApps();
				return !!apps.find(function (i) {
					return i.id === id || i.trackingId === id;
				});
			} catch (e) {
				reject(e);
			}
		});

		return function (_x2, _x3) {
			return _ref2.apply(this, arguments);
		};
	})());

	// returns a promise which resolves information about all of the current open apps within the current workspace
	// note that the Discovery Bar must be the parent app in order to get a reply
	// if you are running in localhost and expect a reply, then you'll need to mock this out
	runtime.getOpenAppsInWorkspace = () => new Promise((resolve, reject) => {
		warnAboutLocalUsage(`getOpenAppsInWorkspace()`);
		try {
			throwErrorIfNoParent('getOpenAppsInWorkspace()');
			runtime.messageTopParent(_context_types__WEBPACK_IMPORTED_MODULE_1__[/* MESSAGE_TYPES */ "c"].GET_OPEN_APPS_IN_WORKSPACE).onReply(message => {
				resolve(message.data);
			});
		} catch (e) {
			reject(e);
		}
	});

	// updates the status of a particular training module
	// note that the Discovery Bar must be the parent app in order for this to work.
	runtime.updateTrainingModuleStatus = data => {
		const getDebugString = prefix => `${prefix} - Consult the runtime docs ${DOCS_URL}#section_Training`;
		if (!data || typeof data !== 'object') {
			throw new Error(getDebugString('No training module payload provided'));
		}
		if (typeof data.id !== 'string') {
			throw new Error(getDebugString('Training Module "id" must be provided and be a string'));
		}
		if (typeof data.status !== 'string') {
			throw new Error(getDebugString('Training Module "status" must be provided and be a string'));
		}
		if (data.data && typeof data.data !== 'object') {
			throw new Error(getDebugString('Training Module "data" must be an object, when provided'));
		}
		warnAboutLocalUsage(`updateTrainingModuleStatus()`);
		contextApi.requestAction({
			type: _context_types__WEBPACK_IMPORTED_MODULE_1__[/* ACTION_TYPES */ "a"].UPDATE_TRAINING_MODULE_STATUS,
			version: 1,
			data: {
				parentId: parent.getParentId(),
				instanceId: ROOT_INSTANCE_ID,
				trainingModule: data
			}
		});
	};

	// open by id						openApp({ id: 'execution' });
	// open with different url			openApp({ id: 'execution', url: '/execution-swap' });
	// open with additional params		openApp({ id: 'execution', urlParams: 'currencyPair=GBPUSD' });
	runtime.openApp = data => {
		const getDebugString = prefix => `${prefix} - Consult the runtime docs ${DOCS_URL}#section_OpeningApps`;
		warnAboutLocalUsage(`openApp()`);
		return new Promise((resolve, reject) => {
			try {
				if (!data || typeof data !== 'object') throw new Error(getDebugString('No options provided'));

				if (typeof data.id !== 'string') throw new Error(getDebugString('No app ID provided'));

				throwErrorIfNoParent('openApp()');
				runtime.messageTopParent(_context_types__WEBPACK_IMPORTED_MODULE_1__[/* MESSAGE_TYPES */ "c"].OPEN_APP, _extends({}, data, {
					parentId: parent.getParentId(),
					instanceId: ROOT_INSTANCE_ID
				})).onReply(message => {
					resolve(message.data);
				});
			} catch (e) {
				reject(e);
			}
		});
	};

	runtime.resetAppUrl = opts => {
		warnAboutLocalUsage(`resetAppUrl()`);
		return new Promise((resolve, reject) => {
			try {
				if (runtime.isLocalhost() && !runtime.getParent()) {
					console.info(`resetAppUrl() local return value is being mocked as ${window.location.pathname}`);
					return resolve(window.location.pathname);
				}
				runtime.messageTopParent(_context_types__WEBPACK_IMPORTED_MODULE_1__[/* MESSAGE_TYPES */ "c"].RESET_APP_URL, _extends({}, opts, {
					parentId: parent.getParentId()
				})).onReply(message => {
					resolve(message.data.url);
				});
			} catch (e) {
				reject(e);
			}
		}).then(url => {
			if (opts && opts.updateLocalUrl) {
				history.pushState({}, '', url);
			}
			if (opts && opts.redirect) {
				window.location.assign(url);
			}
			return url;
		});
	};

	// reply back to any modal creation requests from children
	runtime.onChildMessage(_context_types__WEBPACK_IMPORTED_MODULE_1__[/* MESSAGE_TYPES */ "c"].OVERLAY_MODAL_CREATE, message => {
		// ignore if this is the discovery bar
		// as we have handling in the app for this
		if (IS_ROOT_INSTANCE) return;

		// we have a request to create a modal from the child
		const modal = Object(_runtime_ui_modal__WEBPACK_IMPORTED_MODULE_4__[/* createLocalModal */ "d"])(_extends({}, message.data, {
			id: `runtime-parent-modal-${runtime.uuid()}`
		}));
		message.reply({
			ok: true,
			data: {
				id: modal.id,
				domElementId: modal.domElementId
			}
		});
	});

	runtime.createModal = optionalData => {
		warnAboutLocalUsage(`createModal()`);
		const parentId = parent.getParentId();
		const instanceId = ROOT_INSTANCE_ID;
		const options = optionalData || {};

		return new Promise((resolve, reject) => {
			if (IS_ROOT_INSTANCE || runtime.isStandAloneWindow() || options.useCurrentWindow) {
				// return a local modal specfic to the app
				const modal = Object(_runtime_ui_modal__WEBPACK_IMPORTED_MODULE_4__[/* createLocalModal */ "d"])(_extends({}, options, {
					id: `runtime-local-modal-${runtime.uuid()}`
				}));
				return resolve(modal);
			}
			const messageTarget = options.useParentWindow ? runtime.messageParent : runtime.messageTopParent;
			try {
				throwErrorIfNoParent('createModal()');
				messageTarget(_context_types__WEBPACK_IMPORTED_MODULE_1__[/* MESSAGE_TYPES */ "c"].OVERLAY_MODAL_CREATE, _extends({}, options, {
					parentId,
					instanceId
				})).onReply(message => {
					if (!message.data.ok) throw new Error('Could not create modal');
					const { id, domElementId } = message.data.data;
					const SUPPRESS_LOCAL_WINDOW_FOCUS = !options.preventFocusSuppression && options.useParentWindow;

					// add local modal class to prevent focus in this app
					if (SUPPRESS_LOCAL_WINDOW_FOCUS) Object(_runtime_ui_modal__WEBPACK_IMPORTED_MODULE_4__[/* addModalBodyClass */ "c"])();

					// here's the api which we return for a modal
					resolve({
						id, // the modals unique id
						getContentElement: () => {
							// returns the content element of the modal
							const windowTarget = options.useParentWindow ? window.parent : window.top;
							if (!windowTarget) throw new Error('parent window does not exist');
							return windowTarget.document.querySelector(`#${domElementId}`);
						},
						close: () => {
							// remove local modal class so that we can focus elements again
							if (SUPPRESS_LOCAL_WINDOW_FOCUS) Object(_runtime_ui_modal__WEBPACK_IMPORTED_MODULE_4__[/* removeModalBodyClass */ "e"])();

							messageTarget(_context_types__WEBPACK_IMPORTED_MODULE_1__[/* MESSAGE_TYPES */ "c"].OVERLAY_MODAL_CLOSE, {
								id,
								parentId,
								instanceId
							});
						}
					});
				});
			} catch (e) {
				reject(e);
			}
		});
	};

	// this will be depricated
	runtime.openAppById = (id, opts) => {
		const rest = opts && typeof opts === 'object' ? opts : {};
		return runtime.openApp(_extends({ id }, rest, { parentId: parent.getParentId() }));
	};

	// registers a handler which is meant to fire when the app is closed.  this is NOT guaranteed to fire due to the way
	// browsers work.
	// https://developer.mozilla.org/en-US/docs/Web/API/Window/beforeunload_event
	runtime.onAppClose = fn => {
		window.addEventListener('beforeunload', fn);
		return () => window.removeEventListener('beforeunload', fn);
	};

	// registers a handler which fires when the app is focused (visible) in the discovery bar
	runtime.onAppFocus = fn => {
		eventBus.on(_context_types__WEBPACK_IMPORTED_MODULE_1__[/* MESSAGE_TYPES */ "c"].APP_FOCUS, fn);
		return () => eventBus.off(_context_types__WEBPACK_IMPORTED_MODULE_1__[/* MESSAGE_TYPES */ "c"].APP_FOCUS, fn);
	};

	// registers a handler which fires when the app is no longer focused (i.e. unselected) in the discovery bar
	runtime.onAppBlur = fn => {
		eventBus.on(_context_types__WEBPACK_IMPORTED_MODULE_1__[/* MESSAGE_TYPES */ "c"].APP_BLUR, fn);
		return () => eventBus.off(_context_types__WEBPACK_IMPORTED_MODULE_1__[/* MESSAGE_TYPES */ "c"].APP_BLUR, fn);
	};

	// returns a boolean indicating if the current app is focused in the Discovery Bar
	runtime.getAppIsFocused = () => {
		warnAboutLocalUsage(`getAppIsFocused()`);
		if (runtime.isStandAloneWindow()) return Promise.resolve(true);
		return new Promise((resolve, reject) => {
			try {
				throwErrorIfNoParent('getAppIsFocused()');
				runtime.messageTopParent(_context_types__WEBPACK_IMPORTED_MODULE_1__[/* MESSAGE_TYPES */ "c"].GET_APP_IS_FOCUSED).onReply(message => {
					resolve(message.data);
				});
			} catch (e) {
				reject(e);
			}
		});
	};

	// returns details of the current app thats running in the Discovery Bar
	runtime.getAppDetails = () => {
		warnAboutLocalUsage(`getAppDetails()`);
		return new Promise((resolve, reject) => {
			try {
				throwErrorIfNoParent('getAppDetails()');
				runtime.messageTopParent(_context_types__WEBPACK_IMPORTED_MODULE_1__[/* MESSAGE_TYPES */ "c"].GET_APP_DETAILS).onReply(message => {
					resolve(message.data);
				});
			} catch (e) {
				reject(e);
			}
		});
	};

	// requests the platform to open the menu
	runtime.openPlatformMenu = () => {
		warnAboutLocalUsage(`openPlatformMenu()`);
		return new Promise((resolve, reject) => {
			try {
				throwErrorIfNoParent('openPlatformMenu()');
				runtime.messageTopParent(_context_types__WEBPACK_IMPORTED_MODULE_1__[/* MESSAGE_TYPES */ "c"].OPEN_PLATFORM_MENU).onReply(message => {
					resolve(message.data);
				});
			} catch (e) {
				reject(e);
			}
		});
	};

	// requests the platform to close the menu
	runtime.closePlatformMenu = () => {
		warnAboutLocalUsage(`closePlatformMenu()`);
		return new Promise((resolve, reject) => {
			try {
				throwErrorIfNoParent('closePlatformMenu()');
				runtime.messageTopParent(_context_types__WEBPACK_IMPORTED_MODULE_1__[/* MESSAGE_TYPES */ "c"].CLOSE_PLATFORM_MENU).onReply(message => {
					resolve(message.data);
				});
			} catch (e) {
				reject(e);
			}
		});
	};

	// requests data about the platform
	runtime.getPlatformStatus = () => {
		warnAboutLocalUsage(`getPlatformStatus()`);
		return new Promise((resolve, reject) => {
			try {
				throwErrorIfNoParent('getPlatformStatus()');
				runtime.messageTopParent(_context_types__WEBPACK_IMPORTED_MODULE_1__[/* MESSAGE_TYPES */ "c"].GET_PLATFORM_STATUS).onReply(message => {
					resolve(message.data);
				});
			} catch (e) {
				reject(e);
			}
		});
	};

	// attach our storage api
	runtime.storage = Object(_remote_storage___WEBPACK_IMPORTED_MODULE_3__[/* default */ "b"])({
		instanceStorage: false,
		isLocalhost: runtime.isLocalhost(),
		hasParent: !!runtime.getParent(),
		waitForParentId: () => parent.waitForParentId(),
		messageParent: runtime.messageTopParent
	});

	// attach our instance storage api
	runtime.instanceStorage = Object(_remote_storage___WEBPACK_IMPORTED_MODULE_3__[/* default */ "b"])({
		instanceStorage: true,
		isLocalhost: runtime.isLocalhost(),
		hasParent: !!runtime.getParent(),
		waitForParentId: () => parent.waitForParentId(),
		messageParent: runtime.messageTopParent
	});

	// setup activity monitoring to notify the platform of recent activity
	if (!isRootInstance) setupActivityBroadcasting({ runtime, parent, rootInstanceId });
};

/* harmony default export */ __webpack_exports__["a"] = (setup);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(8)))

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./src/polyfills/broadcast-channel.js
var broadcast_channel = __webpack_require__(9);

// CONCATENATED MODULE: ./src/communication/ChannelManager.js
const channelMap = {};

let ChannelManager = class ChannelManager {
	constructor() {
		if (this.instance) {
			return this.instance;
		}
		this.instance = this;
	}
	create(channelName) {
		return channelMap[channelName] = channelMap[channelName] || new BroadcastChannel(channelName);
	}

	get channels() {
		return channelMap;
	}

	getChannel(name) {
		return channelMap[name];
	}
};

// EXTERNAL MODULE: ./node_modules/events/events.js
var events = __webpack_require__(2);

// CONCATENATED MODULE: ./src/communication/MessageInterface.js
/* eslint-disable no-unused-vars */




let MessageInterface_MessageInterface = class MessageInterface extends events["EventEmitter"] {
	constructor() {
		super();
		if (this.instance) {
			return this.instance;
		}
		this.channelManager = new ChannelManager();
		this.instance = this;
		this.register();
	}

	register() {
		this.name = window.name || `anonymous-${window.location.href}`;
	}

	subscribe(channelName, topic, callback) {
		let channel = this.channelManager.getChannel(channelName);
		if (!channel) {
			channel = this.channelManager.create(channelName);
		}
		const listener = e => {
			if (e.data.topic && e.data.topic === topic) {
				callback(e);
			}
		};
		channel.addEventListener('message', listener);
		return () => channel.removeEventListener('message', listener);
	}

	send(channelName, topic, data, options) {
		const payload = { topic, data, name: this.name };
		const channel = this.channelManager.getChannel(channelName);
		if (channel) {
			channel.postMessage(payload);
		}
	}

	broadcast(topic, data, options) {
		Object.keys(this.channelManager.channels).forEach(channelName => {
			this.channelManager.getChannel(channelName).postMessage({ topic, data });
		});
	}
};

// CONCATENATED MODULE: ./src/runtime/ui/index.js
/* eslint-disable no-unused-vars */

const TOOLS_TEMPLATE = ({ minimize, close } = {}) => `
${minimize !== false ? `<button type="button" class="ev-button ev-button--icon ev-button--borderless minimize" aria-label="Minimize Application">
<svg class="fill" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
    <g>
        <path d="M5 13.2h10v1.7H5z"></path>
    </g>
</svg>
</button>` : ''}
${close !== false ? `<button type="button" class="ev-button ev-button--icon ev-button--borderless close" aria-label="Close Application">
<svg class="fill" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
    <path d="M15 6.4L13.6 5 10 8.6 6.4 5 5 6.4 8.6 10 5 13.6 6.4 15l3.6-3.6 3.6 3.6 1.4-1.4-3.6-3.6z"></path>
</svg>
</button>` : ''}`;

const HEADER_TARGET_SELECTOR = '.ev-window__header';
const TITLE_TARGET_SELECTOR = '.ev-window__title';

const deriveLikelyEnvironment = () => {
	const map = {
		uat: 'uat',
		sit: 'sit',
		localhost: 'dev'
	};
	const [match, capture] = document.location.host.match(/[-.]?(uat|sit|localhost)[-.]?/) || [];
	if (match && capture) {
		return map[capture];
	}
	return '';
};

const updateMetaThemeColour = colour => {
	const getThemeColorElement = () => {
		const el = document.querySelector('meta[name=theme-color]');
		if (el) return el;
		const newEl = document.createElement('meta');
		newEl.setAttribute('name', 'theme-color');
		document.getElementsByTagName('head')[0].appendChild(newEl);
		return newEl;
	};
	getThemeColorElement().setAttribute('content', colour);
};

// updates the theme of the window to be dark or light, depending on the boolean passed in
const changeTheme = (useDarkTheme, runtime) => {
	if (runtime.getInitiallyOpenedInNonPWABrowser() && runtime.isProgressiveWebApp()) {
		console.error('Disabling theme switching in PWA due to known browser PWA bug.');
		console.error('Changes to the body element background color destroys the UI in a PWA which was opened from the browser.');
		console.error('Theme switch will work next time PWA is opened standalone (i.e. not via native browser).');
		return;
	}
	const DARK_CLASS = 'ev-theme-dark';
	const LIGHT_CLASS = 'ev-theme-light';
	const node = document.querySelector('body');
	if (!node) {
		// script has loaded before dom is ready
		const retryOnLoad = () => changeTheme(useDarkTheme, runtime);
		return document.addEventListener('DOMContentLoaded', retryOnLoad, false);
	}
	node.classList.remove(useDarkTheme ? LIGHT_CLASS : DARK_CLASS);
	node.classList.add(useDarkTheme ? DARK_CLASS : LIGHT_CLASS);
	updateMetaThemeColour(useDarkTheme ? '#1d262c' : '#fff');
};

const injectHsbcLogo = () => {
	const node = document.querySelector(TITLE_TARGET_SELECTOR);
	if (!node) return;
	const logoHtml = `
	<svg height="16" width="16" viewbox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" style="position:relative;top:-1px;vertical-align:middle;margin-left:-2px;display:inline-block;margin-right:4px;">
        <g fill="none" fill-rule="evenodd">
            <path fill="#DB0011" d="M0 0h16v16H0z" />
            <path d="M10.56 5.44L7.895 8.107 5.227 5.44H10.56zm-5.333 5.333L2.56 8.108 5.227 5.44v5.333zM10.56 5.44l2.667 2.665-2.667 2.668V5.44zm0 5.333H5.227l2.668-2.666 2.665 2.666z"
             fill="#FFF" />
        </g>
    </svg>`;
	const parser = new DOMParser();
	const html = parser.parseFromString(logoHtml, 'text/html');
	node.prepend(html.body.firstChild);
};

const injectStandaloneCssClasses = isRetry => {
	const node = document.querySelector('body');
	if (!node) {
		if (isRetry) return;
		const retryOnLoad = () => injectStandaloneCssClasses(true);
		return document.addEventListener('DOMContentLoaded', retryOnLoad, false);
	}
	node.classList.add('ev-custom-frame');
	const ENV = deriveLikelyEnvironment();
	if (ENV) {
		node.classList.add(`ev-env--${ENV}`);
	}
};

const injectMinimizeAndCloseButtons = ({ minimize = true, close = true }) => {
	const placementNode = document.querySelector(HEADER_TARGET_SELECTOR);
	if (placementNode) {
		const frag = document.createRange().createContextualFragment(TOOLS_TEMPLATE({ minimize, close }));
		minimize && frag.querySelector('.minimize').addEventListener('click', e => evolveRuntime.getCurrentWindow().minimize());
		close && frag.querySelector('.close').addEventListener('click', e => evolveRuntime.closeCurrent());
		placementNode.appendChild(frag);
		window.addEventListener('keydown', e => {
			switch (e.key) {
				case 'm':
					if (e.ctrlKey || e.metaKey) {
						minimize && evolveRuntime.getCurrentWindow().minimize();
					}
					break;
				case 'w':
					if (e.ctrlKey || e.metaKey) {
						close && evolveRuntime.closeCurrent();
					}
					break;
			}
		});
	}
};

// ensures that we should actually hide the app's header
const headerCanBeManipulated = el => {
	if (!el) return false;
	// return false if the header has anything other than a child text node inside it
	if (el.children.length !== 1) return false; // should only be one child (the title)
	if (el.children[0].children.length) return false; // the title should only contain text
	return true;
};

const hideAppHeader = () => {
	const el = document.querySelector('.ev-window__header');
	if (!headerCanBeManipulated(el)) return;
	el.style.display = 'none';
};

const showAppHeader = () => {
	const el = document.querySelector('.ev-window__header');
	if (!headerCanBeManipulated(el)) return;
	el.style.display = 'flex';
};

const checkAppHeaderVisibility = runtime => {
	if (runtime.shouldHideAppHeader()) {
		hideAppHeader();
	} else {
		showAppHeader();
	}
};

// checks the apps iframe, and updates the app header visibility, when appropriate
const observeiFrameAttributeChanges = runtime => {
	if (!runtime) return;
	if (!window.frameElement) return;
	if (!MutationObserver) return;

	const observer = new MutationObserver(mutations => {
		const attributesChanged = mutations.some(function (mutation) {
			if (mutation.type === 'attributes') return true;
			return false;
		});
		if (attributesChanged) {
			checkAppHeaderVisibility(runtime);
		}
	});

	observer.observe(window.frameElement, {
		attributes: true,
		childList: false,
		subtree: false,
		attributeFilter: [runtime.HIDE_APP_HEADER_TAG]
	});

	try {
		checkAppHeaderVisibility(runtime);
	} catch (e) {
		console.error(e);
	}
};

const updateBodyScenarioClasses = (runtime, isRetry) => {
	const node = document.querySelector('body');
	if (!node) {
		if (isRetry) return;
		const retryOnLoad = () => updateBodyScenarioClasses(runtime, true);
		return document.addEventListener('DOMContentLoaded', retryOnLoad, false);
	}
	const dependingOn = test => ({
		toggleClass: i => test ? node.classList.add(i) : node.classList.remove(i)
	});
	const BODY_CLASSES = {
		SCENARIO_WORKSPACE: 'ev-scenario--workspace',
		SCENARIO_NON_WORKSPACE: 'ev-scenario--non-workspace',
		SCENARIO_HIDE_APP_HEADER: 'ev-scenario--hide-app-header'
	};
	dependingOn(runtime.isInWorkspace()).toggleClass(BODY_CLASSES.SCENARIO_WORKSPACE);
	dependingOn(!runtime.isInWorkspace()).toggleClass(BODY_CLASSES.SCENARIO_NON_WORKSPACE);
	dependingOn(runtime.shouldHideAppHeader()).toggleClass(BODY_CLASSES.SCENARIO_HIDE_APP_HEADER);
	checkAppHeaderVisibility(runtime);
};

const injectDeviceCssClasses = (opts, isRetry) => {
	const node = document.querySelector('body');
	if (!node) {
		if (isRetry) return;
		const retryOnLoad = () => injectDeviceCssClasses(opts, true);
		return document.addEventListener('DOMContentLoaded', retryOnLoad, false);
	}
	if (opts.isBrowser) node.classList.add(`ev-device--browser`);
	if (opts.isPWA) node.classList.add(`ev-device--browser-pwa`);
	if (opts.isOpenFin) node.classList.add(`ev-device--openfin`);
};

const addDeviceClasses = ({ isBrowser, isOpenFin, isPWA }) => {
	injectDeviceCssClasses({ isBrowser, isOpenFin, isPWA });
};

const appendTools = ({ minimize = true, close = true, title = '' } = {}, isStandAloneWindow = true) => {
	if (isStandAloneWindow) {
		injectHsbcLogo();
		injectStandaloneCssClasses();
		injectMinimizeAndCloseButtons({ minimize, close });
	}
};

const getAppHeaderText = () => {
	const titleNode = document.querySelector(TITLE_TARGET_SELECTOR);
	if (titleNode && titleNode.innerText) {
		return titleNode.innerText.trim();
	}
	return '';
};
// CONCATENATED MODULE: ./src/runtime/base/AbstractRuntime.js
var _class,
    AbstractRuntime_temp,
    AbstractRuntime_this = undefined;

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

/* eslint-disable no-unused-vars */




const messaging = new MessageInterface_MessageInterface();
const PUBLIC_BUS = 'crossApplicaitonMessageBus';

const warn = method => {
	return Promise.reject(console.warn(`Runtime instance does not implement method "${method}"`));
};

const s4 = () => {
	return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
};

const createUuid = () => {
	return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
};

const createShortUuid = () => {
	return s4() + s4();
};

const STATIC_UUID = createUuid();

const INITIALLY_NON_PWA_BROWSER_SESSION_KEY = 'evolve.runtime.initiallyOpenedInNonPWABrowser';

//Runtime methods mostly wrap the underlying code with a Promise pattern to allow thenable programming - you can of course still call these methods without using the async/await style
let AbstractRuntime_Runtime = (AbstractRuntime_temp = _class = class Runtime {

	static uuid() {
		return createUuid();
	}

	static shortUuid() {
		return createShortUuid();
	}

	constructor(windowRef, initialOptions) {
		this.getName = Runtime.getName;
		this.getId = Runtime.getId;
		this.onMessage = Runtime.onMessage;
		this.broadcastMessage = Runtime.broadcastMessage;

		this.on = (eventName, listener) => {
			//the on method should return a function that unregisters the listener so we don't have to maintain loops of registeres listeners
			return warn('on');
		};

		this.close = _asyncToGenerator(function* () {
			return warn('close');
		});

		this.resizeTo = (() => {
			var _ref2 = _asyncToGenerator(function* ({ width, height }) {
				return warn('resizeTo');
			});

			return function (_x) {
				return _ref2.apply(this, arguments);
			};
		})();

		this.resizeBy = (() => {
			var _ref3 = _asyncToGenerator(function* ({ width, height }) {
				return warn('resizeBy');
			});

			return function (_x2) {
				return _ref3.apply(this, arguments);
			};
		})();

		this.show = () => {};

		this.hide = () => {};

		this.focus = (() => {
			var _ref4 = _asyncToGenerator(function* ({ win = window }) {
				return warn('focus');
			});

			return function (_x3) {
				return _ref4.apply(this, arguments);
			};
		})();

		this.blur = _asyncToGenerator(function* () {
			return warn('blur');
		});

		this.minimize = () => {
			return warn('minimize');
		};

		this.setBounds = (() => {
			var _ref6 = _asyncToGenerator(function* ({ left, top, width, height, callback, errorCallback }) {
				return warn('setBounds');
			});

			return function (_x4) {
				return _ref6.apply(this, arguments);
			};
		})();

		this.__window = windowRef || this._attachCurrentWindow();
		this.__initialOptions = initialOptions || {};
		this.__closed = false;
		this.__performance = {
			runtimeInitTime: 0,
			windowLoadTime: 0,
			totalLoadTime: 0
		};
		this.init(...arguments);
	}

	init() {
		//stub to override
	}

	static getName() {
		const name = window.name; // APP_ID_TAG
		const pathname = document.location.pathname;
		const addSuffix = str => `${str}___${STATIC_UUID}`;
		if (name !== '') {
			return name;
		}
		if (pathname !== '' && pathname !== '/') {
			return addSuffix(pathname).replace('/', '');
		}
		return addSuffix('index');
	}

	// make available on the instance

	static getId() {
		return Runtime.getName();
	}

	// make available on the instance

	setFriendlyName(name) {} // depricated
	setFriendlyDescription() {} // depricated
	setDerivedTitle() {} // depricated

	// subscribe to messages
	static onMessage(message, fn) {
		const callback = event => fn(event.data.data);
		return messaging.subscribe(PUBLIC_BUS, message, callback);
	}

	// make available on the instance

	// broadcast a message to all windows
	static broadcastMessage(message, data) {
		return messaging.send(PUBLIC_BUS, message, data);
	}

	// make available on the instance

	getPerformanceStats() {
		return this.__performance;
	}

	setPerformanceStats(runtimeInitTime, windowLoadTime) {
		const totalLoadTime = runtimeInitTime + windowLoadTime;
		this.__performance = {
			runtimeInitTime,
			windowLoadTime,
			totalLoadTime
		};
	}

	static ready() {
		return _asyncToGenerator(function* () {
			return new Promise(function (resolve) {
				if (document.readyState === 'complete' || document.readyState === 'loaded') {
					resolve(); // document is already ready to go
				} else {
					window.addEventListener('DOMContentLoaded', function () {
						return resolve();
					});
				}
			});
		})();
	}

	static focusDiscoveryBarWindow() {
		if (Runtime.isStandAloneWindow() && Runtime.getTopParent()) {
			const { name } = Runtime.getTopParent();
			if (name !== Runtime.getName()) {
				window.open('', name);
			}
		}
	}

	get window() {
		return this.__window;
	}
	get nativeWindow() {
		return this.__window;
	}

	static getCurrentWindow() {
		//must be overloaded
		return warn();
	}

	get closed() {
		return this.__closed;
	}

	setClosed() {
		this.__closed = true;
	}

	_attachCurrentWindow() {
		return warn('No method has been provided to attach a window reference');
	}

	get width() {
		return this.nativeWindow.innerWidth;
	}

	get height() {
		return this.nativeWindow.innerHeight;
	}

	// returns the max and min window boundaries


	static injectUITools() {}

	static addDeviceClasses() {
		return warn('not implemented');
	}

	static clearCache() {
		return _asyncToGenerator(function* () {
			return Promise.resolve();
		})();
	}

	static openWithBrowser(url) {
		return window.open(url);
	}

	static setInitiallyOpenedInNonPWABrowser() {
		if (window.sessionStorage) {
			window.sessionStorage.setItem(INITIALLY_NON_PWA_BROWSER_SESSION_KEY, true);
		}
	}

	static getInitiallyOpenedInNonPWABrowser() {
		if (window.sessionStorage) {
			return !!window.sessionStorage.getItem(INITIALLY_NON_PWA_BROWSER_SESSION_KEY);
		}
		return false;
	}

	flash() {}
	stopFlash() {}

	maximize() {
		return warn('maximize');
	}

	restore() {
		return warn('restore');
	}

	bringToFront() {}

	static screen() {
		return _asyncToGenerator(function* () {
			return _asyncToGenerator(function* () {
				return warn('getScreenInfo');
			});
		})();
	}

	static isOpenFin() {
		return false;
	}

	static isBrowser() {
		return false;
	}

	static isProgressiveWebApp() {
		if (Runtime.isOpenFin()) {
			return false;
		}
		return typeof window.matchMedia === 'function' && window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone || typeof document.referrer.includes === 'function' && document.referrer.includes('android-app://');
	}

	get initialOptions() {
		return this.__initialOptions;
	}

	get parent() {
		return null;
	}

	updateOptions() {
		return Promise.resolve(this);
	}

	static getLogs() {
		return _asyncToGenerator(function* () {
			return Promise.resolve();
		})();
	}

	static keepWithinScreen() {
		console.warn('keepWithinScreen() has been deprecated as Openfin is no longer used.  There is no need to call this method.');
	}

	static updateBodyElementClasses() {
		updateBodyScenarioClasses(window.evolveRuntime);
	}

	static isLocalhost() {
		const { hostname } = window.location;
		return hostname === 'localhost' || hostname === '127.0.0.1';
	}

	static getParent() {
		if (window.opener) return window.opener; // its a windowed app
		if (window.parent !== window) return window.parent; // it has a parent
		return null;
	}

	static getTopParent() {
		if (window.opener) return window.opener; // its a windowed app
		if (window.top !== window) return window.top; // it has an uppsermost parent / top
		return null;
	}

	static messageTopParent(eventName, data) {
		return Runtime.messageParent(eventName, data, true);
	}

	static messageParent(eventName, data, useTop) {
		const wantsTopParent = typeof useTop === 'boolean' && useTop;
		const parent = wantsTopParent ? Runtime.getTopParent() : Runtime.getParent();

		if (!parent) return { eventUuid: null, onReply: () => {} };

		const { eventUuid } = Runtime._messageWindow(parent, eventName, data, 'RUNTIME_MESSAGE_SOURCE_CHILD');
		return {
			eventUuid,
			onReply: fn => Runtime._onMessage(eventUuid, fn, eventUuid)
		};
	}

	static messageChild(child, eventName, data) {
		const { eventUuid } = Runtime._messageWindow(child, eventName, data, 'RUNTIME_MESSAGE_SOURCE_PARENT');
		return {
			eventUuid,
			onReply: fn => Runtime._onMessage(eventUuid, fn, eventUuid)
		};
	}

	static _messageWindow(target, eventName, data, scope) {
		if (!target) return;
		const payload = { event: eventName, data };
		const isDev = Runtime.isLocalhost();
		const targetOrigin = isDev ? '*' : window.location.origin;
		const eventUuid = createUuid();
		target.postMessage({
			scope,
			payload,
			sourceId: Runtime.getName(),
			eventUuid
		}, targetOrigin);
		return { eventUuid };
	}

	static onParentMessage(eventName, fn) {
		return Runtime._onMessage(eventName, fn, 'RUNTIME_MESSAGE_SOURCE_PARENT');
	}

	static onChildMessage(eventName, fn) {
		return Runtime._onMessage(eventName, fn, 'RUNTIME_MESSAGE_SOURCE_CHILD');
	}

	static _onMessage(eventName, fn, scope) {
		const { origin, hostname } = window.location;
		const handler = e => {
			if (!eventName) return;
			if (!e) return;
			if (!Runtime.isLocalhost() && e.origin !== origin) return;
			if (!e.data) return;
			if (e.data.scope !== scope) return;
			if (!e.data.payload) return;
			if (e.data.payload.event !== eventName) return;
			fn({
				data: e.data.payload.data,
				event: e.data.payload.event,
				sourceId: e.data.sourceId,
				origin: e.origin,
				source: e.source,
				eventUuid: e.data.eventUuid,
				reply: data => Runtime._messageWindow(e.source, e.data.eventUuid, data, e.data.eventUuid)
			});
		};
		window.addEventListener('message', handler, false);
		return () => window.removeEventListener('message', handler, false);
	}

	// indicates if the app is running in a window (not an iframe)
	static isStandAloneWindow() {
		return !window.frameElement;
	}

	// indicates if the app is running in Evolve
	static isRunningInEvolve() {
		const top = Runtime.getTopParent();
		try {
			if (top) {
				return window.top.document.location.pathname.indexOf('/discovery-bar/') !== -1;
			}
			return false;
		} catch (e) {
			window.console.error(e);
			return false;
		}
	}

	static isInWorkspace() {
		return !!(window.frameElement && window.frameElement.hasAttribute(Runtime.WORKSPACE_ID_TAG));
	}

	static getWorkspaceId() {
		return window.frameElement && window.frameElement.getAttribute(Runtime.WORKSPACE_ID_TAG);
	}

	static getWorkspaceAppId() {
		return window.frameElement && window.frameElement.getAttribute(Runtime.WORKSPACE_APP_ID_TAG);
	}

	static isInWorkspaceWithAppId(id) {
		return !!(Runtime.isInWorkspace() && Runtime.getWorkspaceAppId() === id);
	}

	static isInStaticWorkspace() {
		return !!(window.frameElement && !window.frameElement.hasAttribute(Runtime.BROWSER_SINGLE_APP_TAG));
	}

	static shouldHideAppHeader() {
		return !!(window.frameElement && window.frameElement.hasAttribute(Runtime.HIDE_APP_HEADER_TAG));
	}

	static captureLogs() {}

	static updateQueryParams(data, url, usePushState = true) {
		usePushState && history.pushState(data, '', url);
	}
}, _class.defaultWidth = 840, _class.defaultHeight = 700, _class.getCurrentWindowBoundaryRestrictions = _asyncToGenerator(function* () {
	return {
		maxHeight: 0,
		minHeight: 0,
		maxWidth: 0,
		minWidth: 0
	};
}), _class.open = (() => {
	var _ref9 = _asyncToGenerator(function* ({
		name,
		url,
		width = 320,
		height = 480,
		top = 10,
		left = 10,
		resizeable = 'no',
		scrollbars = 'no',
		status = 'no'
	}) {
		return warn('open');
	});

	return function (_x5) {
		return _ref9.apply(this, arguments);
	};
})(), _class.openWindow = opts => AbstractRuntime_this.open(opts), _class.injectEvolveEventSource = (timeout = 10000, url = '/sse-router/assets/eventsource') => {
	const scriptTagId = 'sse-router-script';
	const scriptElement = document.getElementById(scriptTagId);

	const logger = 'evolve.runtime.sse-router.eventsource.injector';
	if (scriptElement) {
		console.info(`${logger} Evolve EventSource Polyfill code already loaded - skipping (sse-router iframe already exists)`);
		return Promise.resolve(true);
	}

	const polyfillInstaller = (resolve, reject) => {
		const timeoutId = setTimeout(() => {
			reject(`Not able to install Evolve EventSource (sse-router) Polyfill - timeout (${timeout}ms)`);
		}, timeout);
		const scriptElement = document.createElement('script');
		scriptElement.id = scriptTagId;
		scriptElement.src = url;
		scriptElement.onerror = event => {
			clearTimeout(timeoutId);
			reject('Not able to load Evolve EventSource (sse-router) Polyfill script: ' + event.target.src);
		};
		scriptElement.onload = () => {
			console.info(`${logger} Evolve EventSource (sse-router) Polyfill code loaded`);
			resolve(true);
		};
		document.head.appendChild(scriptElement);
	};

	return new Promise(polyfillInstaller);
}, _class.navigateTo = url => {}, _class.BROWSER_SINGLE_APP_TAG = 'data-ev-browser-app', _class.APP_ID_TAG = 'name', _class.WORKSPACE_ID_TAG = 'data-ev-workspace-id', _class.WORKSPACE_APP_ID_TAG = 'data-ev-workspace-app-id', _class.HIDE_APP_HEADER_TAG = 'data-ev-hide-app-header', AbstractRuntime_temp);

// CONCATENATED MODULE: ./src/runtime/browser/EventMap.js
//"why the duplicates?" you ask, so that the api is standardised across of and window - more idiot proof

const EVENT_MAP = {
	resize: 'resize',
	resizing: 'resize',
	closed: 'beforeunload',
	close: 'beforeunload',
	beforeunload: 'beforeunload',
	focus: 'focus',
	blur: 'blur'
};
// CONCATENATED MODULE: ./src/runtime/browser/WindowRuntime.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var WindowRuntime_class, _temp2;

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function WindowRuntime_asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }





let INTERCEPTED_LOGS = [];

const centerCoordsForScreen = (appWidth, appHeight) => {
	const { width, height } = screen;
	return {
		top: height / 2 - appHeight / 2,
		left: width / 2 - appWidth / 2
	};
};

const OPEN_WINDOWS = {
	store: [],
	add: runtime => {
		if (!runtime) {
			window.console.warn('no runtime provided');
			return;
		}
		return OPEN_WINDOWS.store.push(runtime);
	},
	remove: runtime => {
		if (!runtime) {
			window.console.warn('no runtime provided');
			return;
		}
		const found = OPEN_WINDOWS.getByName(runtime.initialOptions.name);
		if (found) {
			const index = OPEN_WINDOWS.store.indexOf(found);
			OPEN_WINDOWS.store.splice(index, 1);
		}
	},
	getByName: name => {
		return OPEN_WINDOWS.store.find(i => {
			return i.initialOptions.name === name;
		});
	}
};

// TODO - HIGH add event normalization for window events - consistency across runtimes... resize, close etc... makes rue the sahpe is the same
let WindowRuntime_WindowRuntime = (_temp2 = WindowRuntime_class = class WindowRuntime extends AbstractRuntime_Runtime {
	constructor(...args) {
		var _temp, _this;

		return _temp = _this = super(...args), this.on = (eventName, callback) => {
			const event = EVENT_MAP[eventName] || eventName;
			this.__window.addEventListener(event, callback);
			return () => {
				this.__window.removeEventListener(event, callback);
			};
		}, this.close = WindowRuntime_asyncToGenerator(function* () {
			_this.window.close();
			return Promise.resolve(_this);
		}), this.resizeTo = (() => {
			var _ref2 = WindowRuntime_asyncToGenerator(function* ({ width, height }, force) {
				// prevent window operations if app is not in control of window it's sitting in
				if (!WindowRuntime.isStandAloneWindow() && force !== true) return Promise.resolve(_this);

				_this.window.resizeTo(width, height);
				return Promise.resolve(_this);
			});

			return function (_x, _x2) {
				return _ref2.apply(this, arguments);
			};
		})(), this.resizeBy = (() => {
			var _ref3 = WindowRuntime_asyncToGenerator(function* ({ width, height }, force) {
				// prevent window operations if app is not in control of window it's sitting in
				if (!WindowRuntime.isStandAloneWindow() && force !== true) return Promise.resolve(_this);

				_this.window.resizeBy(width, height);
				return Promise.resolve(_this);
			});

			return function (_x3, _x4) {
				return _ref3.apply(this, arguments);
			};
		})(), this.focus = WindowRuntime_asyncToGenerator(function* () {
			_this.window.focus();
			return Promise.resolve(_this);
		}), this.setBounds = (() => {
			var _ref5 = WindowRuntime_asyncToGenerator(function* ({ left, top, width, height }, force) {
				// prevent window operations if app is not in control of window it's sitting in
				if (!WindowRuntime.isStandAloneWindow() && force !== true) return Promise.resolve(_this);

				_this.__restoreCoords = { left, top, width, height };
				_this.resizeTo({ width, height });
				_this.moveTo({ left, top });
				return Promise.resolve(_this);
			});

			return function (_x5, _x6) {
				return _ref5.apply(this, arguments);
			};
		})(), this.moveTo = (() => {
			var _ref6 = WindowRuntime_asyncToGenerator(function* ({ left, top }, force) {
				// prevent window operations if app is not in control of window it's sitting in
				if (!WindowRuntime.isStandAloneWindow() && force !== true) return Promise.resolve(_this);

				_this.window.moveTo(left, top);
				Promise.resolve(_this);
			});

			return function (_x7, _x8) {
				return _ref6.apply(this, arguments);
			};
		})(), this.moveBy = (() => {
			var _ref7 = WindowRuntime_asyncToGenerator(function* ({ left, top }, force) {
				// prevent window operations if app is not in control of window it's sitting in
				if (!WindowRuntime.isStandAloneWindow() && force !== true) return Promise.resolve(_this);

				_this.window.moveBy(left, top);
				Promise.resolve(_this);
			});

			return function (_x9, _x10) {
				return _ref7.apply(this, arguments);
			};
		})(), this.minimize = WindowRuntime_asyncToGenerator(function* () {
			_this.__restoreCoords = {
				top: window.screenTop,
				left: _this.window.screenLeft,
				height: _this.window.innerHeight,
				width: _this.window.innerWidth
			};
			yield _this.resizeTo({ width: 0, height: 0 });
			return _this.moveTo({ left: screen.availWidth, top: screen.availHeight });
		}), this.getBounds = WindowRuntime_asyncToGenerator(function* () {
			const bounds = {
				top: _this.window.screenTop,
				left: _this.window.screenLeft,
				height: _this.window.innerHeight,
				width: _this.window.innerWidth
			};
			return Promise.resolve(bounds);
		}), this.restore = () => {
			if (this.__restoreCoords) {
				const { top, left, height, width } = this.__restoreCoords;
				this.resizeTo({ width, height });
				return this.moveTo({ left, top });
			}
			return Promise.resolve(this);
		}, this.maximize = () => {
			return Promise.resolve();
		}, _temp;
	}

	_attachCurrentWindow() {
		return window;
	}

	init() {
		if (window === this.__window) {
			window.__evolveRuntimeWindowRef = this;
		}
		if (WindowRuntime.isBrowser() && !WindowRuntime.isProgressiveWebApp()) {
			WindowRuntime.setInitiallyOpenedInNonPWABrowser();
		}
		setTimeout(() => {
			observeiFrameAttributeChanges(window.evolveRuntime);
		}, 1);
	}

	static clearCache(opts) {
		return WindowRuntime_asyncToGenerator(function* () {
			return new Promise(function (resolve, reject) {
				try {
					// clears down all local storage
					if (opts && opts.localStorage) window.localStorage.clear();

					if (opts && (opts.localStorage || opts.runtimeLocalStorage)) {
						// clears down just evolve runtime local storage
						Object.keys(localStorage).forEach(function (key) {
							if (typeof key === 'string' && key.indexOf('evolve.runtime.') === 0) localStorage.removeItem(key);
						});
					}

					if (opts && opts.cookies) {
						// clear the cache
						const cookies = document.cookie.split('; ');
						for (let c = 0; c < cookies.length; c += 1) {
							const d = window.location.hostname.split('.');
							while (d.length > 0) {
								const cookieBase = `${encodeURIComponent(cookies[c].split(';')[0].split('=')[0])}=; expires=Thu, 01-Jan-1970 00:00:01 GMT; domain=${d.join('.')} ;path=`;
								const p = location.pathname.split('/');
								document.cookie = `${cookieBase}/`;
								while (p.length > 0) {
									document.cookie = cookieBase + p.join('/');
									p.pop();
								}
								d.shift();
							}
						}
					}

					resolve();
				} catch (e) {
					reject(e);
				}
			});
		})();
	}

	static shutdown() {
		WindowRuntime.close();
	}

	static closeCurrent() {
		WindowRuntime.close();
	}

	static close() {
		WindowRuntime.getCurrentWindow().close();
	}

	static getCurrentWindow() {
		return new WindowRuntime(window, window.__evolveRuntimeWindowRef.initialOptions);
	}

	static screen() {
		return WindowRuntime_asyncToGenerator(function* () {
			return Promise.resolve([{ screen, screenLeft, screenTop }]);
		})();
	}

	bringToFront() {
		return this.restore().then(() => {
			this.window.focus();
		});
	}

	static isBrowser() {
		return true;
	}

	// returns an array of the latest openfin logs in a promise
	// each item in the array has the following structure:
	// type LogList = Array<{ date: Date, size: number, name: string, log: string }>;
	static getLogs() {
		return WindowRuntime_asyncToGenerator(function* () {
			return Promise.resolve([{
				date: new Date(),
				size: 25,
				name: 'debug.log',
				log: INTERCEPTED_LOGS.join('\n')
			}]);
		})();
	}
}, WindowRuntime_class.ready = WindowRuntime_asyncToGenerator(function* () {
	return new Promise(function (resolve) {
		if (document.readyState === 'loading') {
			// Loading hasn't finished yet
			document.addEventListener('DOMContentLoaded', function () {
				return resolve();
			});
		} else {
			// `DOMContentLoaded` has already fired
			resolve();
		}
	});
}), WindowRuntime_class.hideAppHeader = () => {
	return hideAppHeader();
}, WindowRuntime_class.showAppHeader = () => {
	return showAppHeader();
}, WindowRuntime_class.addDeviceClasses = () => {
	addDeviceClasses({
		isBrowser: WindowRuntime_WindowRuntime.isBrowser(),
		isOpenFin: WindowRuntime_WindowRuntime.isOpenFin(),
		isPWA: WindowRuntime_WindowRuntime.isProgressiveWebApp()
	});
	WindowRuntime_WindowRuntime.updateBodyElementClasses();
}, WindowRuntime_class.injectUITools = ({ title = '' } = {}) => {
	WindowRuntime_WindowRuntime.addDeviceClasses();
	if (title) {
		window.document.title = title;
	}
	evolveRuntime.updateAppMetadata({ title: getAppHeaderText() });
}, WindowRuntime_class.navigateTo = url => {
	window.document.location = url;
}, WindowRuntime_class.captureLogs = () => {
	console.log('Evolve Runtime is capturing browser logs');
	const softLimit = 500;
	const hardLimit = softLimit + 250;
	const err = console.error;
	const intercept = function (name) {
		const prev = console[name];
		console[name] = function () {
			prev.apply(console, arguments);
			try {
				const logStr = Array.prototype.join.call(arguments, ' ');
				INTERCEPTED_LOGS.push(new Date().toISOString() + ' - ' + logStr);
				if (INTERCEPTED_LOGS.length > hardLimit) {
					INTERCEPTED_LOGS = INTERCEPTED_LOGS.slice(INTERCEPTED_LOGS.length - softLimit);
				}
			} catch (e) {
				err(e);
			}
		};
	};
	const overrides = ['log', 'info', 'error', 'warn'];
	overrides.forEach(intercept);
}, WindowRuntime_class.openWithBrowser = (() => {
	var _ref11 = WindowRuntime_asyncToGenerator(function* (url) {
		const win = window.open(url);
		const wrappedWindow = new WindowRuntime_WindowRuntime(win, {});
		return Promise.resolve(wrappedWindow);
	});

	return function (_x11) {
		return _ref11.apply(this, arguments);
	};
})(), WindowRuntime_class.openForeignApp = (() => {
	var _ref12 = WindowRuntime_asyncToGenerator(function* (opts) {
		if (!opts || typeof opts !== 'object') throw new Error('No options provided');
		if (typeof opts.url !== 'string') throw new Error('No Url provided');
		return WindowRuntime_WindowRuntime.openWithBrowser(opts.url);
	});

	return function (_x12) {
		return _ref12.apply(this, arguments);
	};
})(), WindowRuntime_class.open = (() => {
	var _ref13 = WindowRuntime_asyncToGenerator(function* (_ref14) {
		let {
			name = `ev-${AbstractRuntime_Runtime.uuid()}`,
			url,
			width = AbstractRuntime_Runtime.defaultWidth,
			height = AbstractRuntime_Runtime.defaultHeight,
			top = 10,
			left = 10,
			resizeable = 'no',
			defaultCentered = true,
			status = 'no'
		} = _ref14,
		    rest = _objectWithoutProperties(_ref14, ['name', 'url', 'width', 'height', 'top', 'left', 'resizeable', 'defaultCentered', 'status']);

		let winCoords = { left, top };

		const hasNoValidPositioning = typeof top !== 'number' || typeof left !== 'number';

		if (hasNoValidPositioning) {
			winCoords = centerCoordsForScreen(width, height);
		}

		const features = `width=${width},height=${height},top=${winCoords.top},left=${winCoords.left},resizeable=${resizeable},status=${status}`;

		const runningApplication = OPEN_WINDOWS.getByName(name);

		const createWindow = function (newWindowRef) {
			const wrapped = new WindowRuntime_WindowRuntime(newWindowRef, _extends({
				name,
				url,
				width,
				height,
				top,
				left,
				defaultCentered
			}, rest));
			OPEN_WINDOWS.add(wrapped);
			return wrapped;
		};

		const win = window.open(url, name, features);
		const windowRuntime = runningApplication ? runningApplication : createWindow(win);

		if (runningApplication) {
			runningApplication.bringToFront();
		}

		windowRuntime.on('closed', function () {
			OPEN_WINDOWS.remove(windowRuntime);
		});

		return Promise.resolve(windowRuntime);
	});

	return function (_x13) {
		return _ref13.apply(this, arguments);
	};
})(), _temp2);

// CONCATENATED MODULE: ./src/settings/store.js
const get = key => ({
	elseReturn: (defaultValue, noParse) => {
		try {
			const parse = noParse ? val => val : JSON.parse;
			const val = parse(window.localStorage.getItem(key));
			return val !== null && val !== undefined ? val : defaultValue;
		} catch (e) {
			return defaultValue;
		}
	}
});

const set = (key, value) => {
	window.localStorage.setItem(key, value);
};

const _KEYS = {
	DARK_THEME: 'evolve.runtime.useDarkTheme',
	DATE_FORMAT: 'evolve.runtime.dateFormat',
	APPS_ALWAYS_ON_TOP: 'evolve.runtime.appsAlwaysOnTop',
	LANGUAGE: 'evolve.runtime.language'
};

const store_EVENTS = {
	THEME_CHANGE: 'THEME_CHANGE',
	DATE_FORMAT_CHANGE: 'DATE_FORMAT_CHANGE',
	LANGUAGE_CHANGE: 'LANGUAGE_CHANGE'
};

const getAppsAlwaysOnTop = () => {
	return get(_KEYS.APPS_ALWAYS_ON_TOP).elseReturn(false);
};

const setAppsAlwaysOnTop = val => {
	return set(_KEYS.APPS_ALWAYS_ON_TOP, !!val);
};

const getUseDarkTheme = () => {
	return get(_KEYS.DARK_THEME).elseReturn(true);
};

const setDarkTheme = () => {
	return set(_KEYS.DARK_THEME, true);
};

const setLightTheme = () => {
	return set(_KEYS.DARK_THEME, false);
};

const setDateFormat = val => {
	if (val !== 'euro' && val !== 'us') return;
	return set(_KEYS.DATE_FORMAT, val);
};

const getDateFormat = () => {
	return get(_KEYS.DATE_FORMAT).elseReturn('euro', true);
};

const setLanguage = val => {
	return set(_KEYS.LANGUAGE, val);
};

const getLanguage = () => {
	return get(_KEYS.LANGUAGE).elseReturn('en', true);
};
// CONCATENATED MODULE: ./src/settings/withSettings.js




// puke.
const updateThemeInUI = runtime => changeTheme(getUseDarkTheme(), runtime);

const localEventEmitter = new events["EventEmitter"]();

function withSettings(Runtime) {
	return class Settings extends Runtime {
		constructor(windowRef, initialOptions) {
			super(windowRef, initialOptions);
			this.initialiseSettings();
			this.setSettingsBroadcastListeners();
		}

		// set the initial ui state here
		initialiseSettings() {
			Settings.refreshSettings();
		}

		// listen out for broadcast changes from other windows
		setSettingsBroadcastListeners() {
			Runtime.onMessage(store_EVENTS.THEME_CHANGE, () => updateThemeInUI(Runtime));
		}

		// allows us to re-read the state and set settings again
		static refreshSettings() {
			updateThemeInUI(Runtime);
		}
		// allows user to find out if dark theme is being used
		static isUsingDarkTheme() {
			return getUseDarkTheme();
		}

		// set the theme
		// runtime.setTheme({ light: boolean })
		// runtime.setTheme({ dark: boolean })
		static setTheme(opts) {
			const getUseLight = () => {
				if (!opts) return false;
				if (typeof opts.light === 'boolean') return opts.light;
				if (typeof opts.dark === 'boolean') return !opts.dark;
				return false;
			};
			const useLight = getUseLight();
			if (useLight) {
				setLightTheme();
			} else {
				setDarkTheme();
			}
			updateThemeInUI(Runtime);
			Runtime.broadcastMessage(store_EVENTS.THEME_CHANGE);

			// done for local testing
			localEventEmitter.emit(store_EVENTS.THEME_CHANGE);
		}

		// toggle the theme from light / dark to the opposite
		static toggleTheme() {
			const setting = getUseDarkTheme();
			if (setting) {
				setLightTheme();
			} else {
				setDarkTheme();
			}
			updateThemeInUI(Runtime);
			Runtime.broadcastMessage(store_EVENTS.THEME_CHANGE);

			// done for local testing
			localEventEmitter.emit(store_EVENTS.THEME_CHANGE);
		}

		// listen for when the theme changes
		static onThemeChange(fn) {
			// done for local testing - as there is no localhost loopback
			localEventEmitter.on(store_EVENTS.THEME_CHANGE, fn);

			// send proper message out
			const remove = Runtime.onMessage(store_EVENTS.THEME_CHANGE, fn);
			return () => {
				localEventEmitter.off(store_EVENTS.THEME_CHANGE, fn);
				remove();
			};
		}

		// listen for when the date format changes
		static onDateFormatChange(fn) {
			return Runtime.onMessage(store_EVENTS.DATE_FORMAT_CHANGE, fn);
		}
		static getDateFormat() {
			return getDateFormat();
		}
		static setDateFormat(format) {
			// format is 'euro' or 'us'
			if (!format) return;
			setDateFormat(format);
			Runtime.broadcastMessage(store_EVENTS.DATE_FORMAT_CHANGE, {
				format: getDateFormat()
			});
		}

		// listen for when the language changes
		static onLanguageChange(fn) {
			return Runtime.onMessage(store_EVENTS.LANGUAGE_CHANGE, fn);
		}
		static getLanguage() {
			return getLanguage();
		}
		static setLanguage(language) {
			setLanguage(language);
			Runtime.broadcastMessage(store_EVENTS.LANGUAGE_CHANGE, {
				language: getLanguage()
			});
		}
	};
}

/* harmony default export */ var settings_withSettings = (withSettings);
// CONCATENATED MODULE: ./src/layout/app-store.js
var app_store_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function app_store_asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

const createStore = () => {
	const map = new Map();
	const ids = [];
	return {
		getAll: () => [...map.values()],
		getLast: () => {
			const lastOpenId = ids[ids.length - 1];
			map.get(lastOpenId) || null;
		},
		add: (id, app) => {
			if (!map.has(id)) ids.push(id);
			map.set(id, app);
			return app;
		},
		remove: id => {
			const index = ids.indexOf(id);
			if (index !== -1) ids.splice(id, 1);
			return map.delete(id);
		},
		get: id => map.get(id) || null
	};
};

const apps = createStore();

const getLastPosition = (() => {
	var _ref = app_store_asyncToGenerator(function* () {
		const lastApp = apps.getLast();
		if (lastApp) {
			try {
				return yield lastApp.getBounds();
			} catch (e) {
				return undefined;
			}
		} else {
			return undefined;
		}
	});

	return function getLastPosition() {
		return _ref.apply(this, arguments);
	};
})();

const constructOpenerArguments = (() => {
	var _ref2 = app_store_asyncToGenerator(function* (args) {
		// TODO - in the future this should be managed in a more intelligent manner
		const lastAppPosition = yield getLastPosition();
		if (lastAppPosition) {
			let { left, top } = lastAppPosition;
			left += 40;
			top += 40;
			return [app_store_extends({ left, top }, args[0])];
		}
		return args;
	});

	return function constructOpenerArguments(_x) {
		return _ref2.apply(this, arguments);
	};
})();

function withApplicationStoreIntegration(baseCls) {
	return class extends baseCls {
		constructor(...args) {
			super(...args);
		}

		static open(...args) {
			return app_store_asyncToGenerator(function* () {
				const openerArgs = yield constructOpenerArguments(args);
				const result = yield baseCls.open(...openerArgs);
				const { initialOptions } = result;
				const id = initialOptions.name;
				apps.add(id, result);
				result.on('closed', function () {
					return apps.remove(id);
				});
				return result;
			})();
		}

		static closeApplications() {
			apps.getAll().forEach(app => app.close());
		}

		static focusApplications() {
			apps.getAll().forEach(app => app.focus());
		}

		static getAppById(id) {
			return apps.get(id);
		}
	};
}

/* harmony default export */ var app_store = (withApplicationStoreIntegration);
// CONCATENATED MODULE: ./src/runtime/index.js




const runtime_Runtime = settings_withSettings(app_store(WindowRuntime_WindowRuntime));

const instance = new runtime_Runtime(); // this is nuts, but, there you go.

/* harmony default export */ var src_runtime = (runtime_Runtime);
// CONCATENATED MODULE: ./src/context/channel.js
const CHANNELS = {
	REGISTRATION: 'evolve-runtime-channel-connection',
	PUBLIC: 'evolve-runtime-*'
};

const advertiseChannelCreation = (name, uuid) => {
	const registration = new BroadcastChannel(CHANNELS.REGISTRATION);
	registration.postMessage({ name, uuid });
	registration.close();
};

const create = (name, uuid) => {
	advertiseChannelCreation(name, uuid);
	return new BroadcastChannel(name);
};

const onChannelCreation = fn => {
	const channel = new BroadcastChannel(CHANNELS.REGISTRATION);
	channel.onmessage = e => {
		fn(e.data);
	};
	return () => channel.close();
};

const createChannel = ({ name, uuid }) => {
	const channel = create(name, uuid);
	const handlers = {};
	const postMessage = (e, data) => {
		channel.postMessage({
			event: e,
			data: data
		});
	};
	const onMessage = (event, callback) => {
		handlers[event] = Array.isArray(handlers[event]) ? handlers[event] : [];
		const eventHandlers = handlers[event];
		eventHandlers.push(callback);
		return () => {
			const index = eventHandlers.findIndex(cb => cb === callback);
			eventHandlers.splice(index, 1);
		};
	};
	channel.onmessage = e => {
		const { event, data } = e.data;
		if (Array.isArray(handlers[event])) {
			handlers[event].forEach(fn => fn(data));
		}
	};
	return {
		message: postMessage,
		onMessage: onMessage,
		close: () => channel.close()
	};
};
// CONCATENATED MODULE: ./src/context/state.js
var state_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function state_objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }



const createState = localSourceId => {
	const collection = new Map(); // contains collection of all known state
	const eventBus = new events["EventEmitter"](); // for internal use
	const PRIVATE_UPDATED_KEY = '$$_last_updated';
	const EVENTS = {
		INTERNAL_STATE_CHANGE: 'INTERNAL_STATE_CHANGE', // internal state has changed
		CONTEXT_DATA_CHANGE: 'CONTEXT_DATA_CHANGE',
		CONTEXT_ACCEPTED_TYPE_CHANGE: 'CONTEXT_ACCEPTED_TYPE_CHANGE',
		CONTEXT_PROVIDED_TYPE_CHANGE: 'CONTEXT_PROVIDED_TYPE_CHANGE',
		ACTION_TYPE_CHANGE: 'ACTION_TYPE_CHANGE',
		SEND_ACTION_REQUEST: 'SEND_ACTION_REQUEST',
		ACTION_REQUEST_RECIEVED: 'ACTION_REQUEST_RECIEVED',
		NUMBER_CONNECTED_CHANGE: 'NUMBER_CONNECTED_CHANGE',
		UNBIND_EVENTS: 'UNBIND_EVENTS'
	};
	const internalState = {
		context: {
			acceptedTypes: [],
			providedTypes: [],
			data: []
		},
		actions: {
			actionTypes: []
		}
	};
	const validateTypeArgs = data => {
		if (!data || typeof data !== 'object') {
			throw new Error('Invalid Type Object Argument');
		}
		if (typeof data.type !== 'string') {
			throw new Error('Type must be a string');
		}
		if (typeof data.version !== 'number') {
			throw new Error('Version must be a number');
		}
	};
	const emitInternalStateChange = () => eventBus.emit(EVENTS.INTERNAL_STATE_CHANGE);
	const addToTypeArray = (arr, data) => {
		const dataArray = Array.isArray(data) ? data : [data];
		dataArray.forEach(d => {
			validateTypeArgs(d);
			if (arr.some(i => i.type === d.type && i.version === d.version)) {
				return;
			}
			arr.push(d);
		});
		emitInternalStateChange();
	};
	const removeFromTypeArray = (arr, data) => {
		validateTypeArgs(data);
		const index = arr.findIndex(i => i.type === data.type && i.version === data.version);
		if (index !== -1) {
			arr.splice(index, 1);
		}
		emitInternalStateChange();
	};
	const getMatchingCollectionData = (getter, { type, version } = {}, {
		enforceUnique, // if we only want one of each type
		internalStateGetter // if we want to combine internal state
	} = {}) => {
		const arr = [];
		const addToArray = (obj, sourceId) => {
			const index = arr.findIndex(i => i.type == obj.type && i.version == obj.version);
			const dataToAdd = state_extends({}, obj, { sourceIds: [sourceId] });
			if (index !== -1) {
				// if exists and has last updated, we use the latest one and dont have multi sources
				if (enforceUnique && arr[index][PRIVATE_UPDATED_KEY]) {
					if (arr[index][PRIVATE_UPDATED_KEY] <= dataToAdd[PRIVATE_UPDATED_KEY]) {
						arr[index] = dataToAdd;
					}
				} else {
					arr[index].sourceIds.push(sourceId);
				}
			} else {
				arr.push(dataToAdd);
			}
		};
		const addMatchesFromState = (state, sourceId) => {
			const matches = state.filter(i => {
				const typeMatch = typeof type === 'string' ? i.type === type : true;
				const versionMatch = typeof version === 'number' ? i.version === version : true;
				return typeMatch && versionMatch;
			});
			matches.forEach(i => addToArray(i, sourceId));
		};
		if (internalStateGetter) {
			addMatchesFromState(internalStateGetter(), localSourceId);
		}
		collection.forEach(state => addMatchesFromState(getter(state), state.sourceId));
		arr.forEach(i => delete i[PRIVATE_UPDATED_KEY]);
		return arr;
	};
	const findMatchingInternalDataIndex = (arr, { type, version }) => {
		return arr.findIndex(i => i.type === type && i.version === version);
	};
	const diff = (oldState, newState, getter) => {
		if (oldState) {
			return JSON.stringify(getter(oldState)) !== JSON.stringify(getter(newState));
		} else if (getter(newState).length) {
			return true;
		} else {
			return false;
		}
	};
	const api = {
		onInternalStateChange: fn => {
			eventBus.on(EVENTS.INTERNAL_STATE_CHANGE, fn);
			return () => eventBus.off(EVENTS.INTERNAL_STATE_CHANGE, fn);
		},
		onContextUpdate: (fn, opts) => {
			if (opts && opts.immediateInvoke) fn();
			eventBus.on(EVENTS.CONTEXT_DATA_CHANGE, fn);
			return () => eventBus.off(EVENTS.CONTEXT_DATA_CHANGE, fn);
		},
		onProvidedContextTypesUpdate: fn => {
			eventBus.on(EVENTS.CONTEXT_PROVIDED_TYPE_CHANGE, fn);
			return () => eventBus.off(EVENTS.CONTEXT_PROVIDED_TYPE_CHANGE, fn);
		},
		onAcceptedContextTypesUpdate: fn => {
			eventBus.on(EVENTS.CONTEXT_ACCEPTED_TYPE_CHANGE, fn);
			return () => eventBus.off(EVENTS.CONTEXT_ACCEPTED_TYPE_CHANGE, fn);
		},
		onActionTypesUpdate: fn => {
			eventBus.on(EVENTS.ACTION_TYPE_CHANGE, fn);
			return () => eventBus.off(EVENTS.ACTION_TYPE_CHANGE, fn);
		},
		onNumberConnectedChange: (fn, opts) => {
			if (opts && opts.immediateInvoke) fn();
			eventBus.on(EVENTS.NUMBER_CONNECTED_CHANGE, fn);
			return () => eventBus.off(EVENTS.NUMBER_CONNECTED_CHANGE, fn);
		},
		addAcceptedContextType: data => {
			addToTypeArray(internalState.context.acceptedTypes, data);
			eventBus.emit(EVENTS.CONTEXT_ACCEPTED_TYPE_CHANGE);
		},
		addProvidedContextType: data => {
			addToTypeArray(internalState.context.providedTypes, data);
			eventBus.emit(EVENTS.CONTEXT_PROVIDED_TYPE_CHANGE);
		},
		addActionType: data => {
			addToTypeArray(internalState.actions.actionTypes, data);
			eventBus.emit(EVENTS.ACTION_TYPE_CHANGE);
		},
		removeAcceptedContextType: data => removeFromTypeArray(internalState.context.acceptedTypes, data),
		removeProvidedContextType: data => removeFromTypeArray(internalState.context.providedTypes, data),
		removeActionType: data => removeFromTypeArray(internalState.actions.actionTypes, data),

		requestAction: (data, target) => {
			// target can be null (sent to all), string (send to one), or array of strings (send to many)
			validateTypeArgs(data);
			const targetArray = typeof target === 'string' ? [target] : target;
			eventBus.emit(EVENTS.SEND_ACTION_REQUEST, { payload: data, target: targetArray });
		},
		onInternalSendActionRequest: fn => {
			eventBus.on(EVENTS.SEND_ACTION_REQUEST, fn);
			return () => eventBus.off(EVENTS.SEND_ACTION_REQUEST, fn);
		},
		receiveActionRequest: opts => {
			validateTypeArgs(opts);
			const matchIndex = findMatchingInternalDataIndex(internalState.actions.actionTypes, opts);
			if (matchIndex !== -1) {
				eventBus.emit(EVENTS.ACTION_REQUEST_RECIEVED, opts);
			}
		},
		onActionRequested: fn => {
			eventBus.on(EVENTS.ACTION_REQUEST_RECIEVED, fn);
			return () => eventBus.off(EVENTS.ACTION_REQUEST_RECIEVED, fn);
		},
		waitForConnections: opts => {
			const DEFAULT_WAIT_DURATION = 5000;
			const DEFAULT_MIN_CONNECTIONS = 1;
			const MIN_CONNECTIONS = opts && typeof opts.minimum === 'number' ? opts.minimum : DEFAULT_MIN_CONNECTIONS;
			const WAIT_DURATION = opts && typeof opts.timeout === 'number' ? opts.timeout : DEFAULT_WAIT_DURATION;
			const getSize = () => collection.size;
			const check = () => getSize() >= MIN_CONNECTIONS;

			return new Promise(resolve => {
				let unbind = () => {};
				let timeoutId = null;
				const done = () => {
					unbind();
					clearTimeout(timeoutId);
					return resolve({ connections: getSize() });
				};
				timeoutId = setTimeout(done, WAIT_DURATION);
				if (check()) return done();
				unbind = api.onNumberConnectedChange(() => {
					if (check()) done();
				});
			});
		},
		setContext: context => {
			const toAdd = Array.isArray(context) ? context : [context];
			const add = data => {
				validateTypeArgs(data);
				const newContext = state_extends({}, data, {
					[PRIVATE_UPDATED_KEY]: Date.now()
				});
				const contextArray = internalState.context.data;
				const index = findMatchingInternalDataIndex(internalState.context.data, newContext);
				if (index !== -1) {
					contextArray[index] = newContext; // update existing context
				} else {
					contextArray.push(newContext); // add context to the array
				}
			};
			toAdd.forEach(add);
			emitInternalStateChange();
			eventBus.emit(EVENTS.CONTEXT_DATA_CHANGE);
		},

		getInternalState: () => internalState,
		addToCollection: (id, newState) => {
			const oldState = collection.get(id);
			const contextChanged = diff(oldState, newState, model => model.context.data);
			const acceptsChanged = diff(oldState, newState, model => model.context.acceptedTypes);
			const providesChanged = diff(oldState, newState, model => model.context.providedTypes);
			const actionsChanged = diff(oldState, newState, model => model.actions.actionTypes);
			collection.set(id, newState);
			if (contextChanged) {
				eventBus.emit(EVENTS.CONTEXT_DATA_CHANGE);
			}
			if (acceptsChanged) {
				eventBus.emit(EVENTS.CONTEXT_ACCEPTED_TYPE_CHANGE);
			}
			if (providesChanged) {
				eventBus.emit(EVENTS.CONTEXT_PROVIDED_TYPE_CHANGE);
			}
			if (actionsChanged) {
				eventBus.emit(EVENTS.ACTION_TYPE_CHANGE);
			}
			if (!oldState) {
				eventBus.emit(EVENTS.NUMBER_CONNECTED_CHANGE);
			}
		},
		removeFromCollection: id => {
			if (!collection.has(id)) {
				return;
			}
			const toBeRemoved = collection.get(id);
			const contextChanged = toBeRemoved.context.data.length;
			const acceptsChanged = toBeRemoved.context.acceptedTypes.length;
			const providesChanged = toBeRemoved.context.providedTypes.length;
			const actionsChanged = toBeRemoved.actions.actionTypes.length;
			collection.delete(id);
			if (contextChanged) {
				eventBus.emit(EVENTS.CONTEXT_DATA_CHANGE);
			}
			if (acceptsChanged) {
				eventBus.emit(EVENTS.CONTEXT_ACCEPTED_TYPE_CHANGE);
			}
			if (providesChanged) {
				eventBus.emit(EVENTS.CONTEXT_PROVIDED_TYPE_CHANGE);
			}
			if (actionsChanged) {
				eventBus.emit(EVENTS.ACTION_TYPE_CHANGE);
			}
			eventBus.emit(EVENTS.NUMBER_CONNECTED_CHANGE);
		},
		getSelfContextData: () => {
			// this is here to debug only
			return getMatchingCollectionData(() => [], {}, {
				internalStateGetter: () => internalState.context.data
			}).map((_ref) => {
				let { sourceIds } = _ref,
				    rest = state_objectWithoutProperties(_ref, ['sourceIds']);

				return rest;
			}); // eslint-disable-line
		},
		getSelfProvidedTypes: () => internalState.context.providedTypes,
		getSelfAcceptedTypes: () => internalState.context.acceptedTypes,
		getSelfActionTypes: () => internalState.actions.actionTypes,
		getCollectionContext: opts => {
			const includeAll = opts && (opts.debug || opts.includeAll);
			if (!internalState.context.acceptedTypes.length && !includeAll) {
				console.warn('getContext() has been called, but no accepted context types have been stated - no matching context data will be returned.  State accepted context types using acceptsContextType() - see runtime docs.');
			}
			const isAcceptedFilter = match => {
				if (includeAll) return true;
				// this filter ensures only data which matches the apps accepted types is returned
				return findMatchingInternalDataIndex(internalState.context.acceptedTypes, match) !== -1;
			};
			const matches = getMatchingCollectionData(state => state.context.data, opts, {
				enforceUnique: true,
				internalStateGetter: () => internalState.context.data
			});
			return matches.filter(isAcceptedFilter);
		},
		getCollectionProvidedTypes: opts => getMatchingCollectionData(state => state.context.providedTypes, opts),
		getCollectionAcceptedTypes: opts => getMatchingCollectionData(state => state.context.acceptedTypes, opts),
		getCollectionActionTypes: opts => getMatchingCollectionData(state => state.actions.actionTypes, opts),
		getCollection: () => collection,
		onUnbind: fn => eventBus.on(EVENTS.UNBIND_EVENTS, fn),
		unbindEvents: () => {
			eventBus.emit(EVENTS.UNBIND_EVENTS);
			eventBus.removeAllListeners();
		}
	};
	return api;
};

// CONCATENATED MODULE: ./src/context/communication.js
var communication_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

const setupCommunication = (channel, uuid, state) => {
	const EVENTS = {
		UPDATE: 'UPDATE', // tell others about you
		DISCONNECTED: 'DISCONNECTED', // tell others you're no longer operating
		DIRECT_MESSAGE: 'DIRECT_MESSAGE', // others have sent a message
		REQUEST_UPDATE: 'REQUEST_UPDATE', // others want to know about you
		PERFORM_ACTION: 'PERFORM_ACTION' // others want to know about you
	};
	const createPayload = (payload = {}) => ({
		source: 'evolve-runtime',
		version: 1,
		data: communication_extends({}, payload, {
			sourceId: uuid
		})
	});

	const decodePayload = data => data.data;

	// broadcast messages - one-to-all messaging
	const onBroadcast = (event, fn) => channel.onMessage(event, data => fn(decodePayload(data)));
	const broadcast = (event, data) => channel.message(event, createPayload(data));

	// unicast messages - one-to-one messaging
	const onUnicast = (event, fn) => channel.onMessage(`${event}-${uuid}`, data => fn(decodePayload(data)));
	const unicast = (targetUuid, event, data) => channel.message(`${event}-${targetUuid}`, createPayload(data));

	const addState = data => state.addToCollection(data.sourceId, data);
	const removeState = data => state.removeFromCollection(data.sourceId);
	const getUpdatePayload = () => state.getInternalState();
	const onActionRequestedRecieved = data => state.receiveActionRequest(data);

	// when others have disconnected
	onBroadcast(EVENTS.DISCONNECTED, removeState);

	// when others want state information from you
	onBroadcast(EVENTS.REQUEST_UPDATE, data => unicast(data.sourceId, EVENTS.UPDATE, getUpdatePayload()));

	// when others send state information about themselves
	onBroadcast(EVENTS.UPDATE, addState);
	onUnicast(EVENTS.UPDATE, addState);

	// when others request an action to be performaed
	onBroadcast(EVENTS.PERFORM_ACTION, onActionRequestedRecieved);
	onUnicast(EVENTS.PERFORM_ACTION, onActionRequestedRecieved);

	// tell others about your state, and request latest state directly from them
	broadcast(EVENTS.UPDATE, getUpdatePayload());
	broadcast(EVENTS.REQUEST_UPDATE);

	// tell others when your state is updated
	state.onInternalStateChange(() => broadcast(EVENTS.UPDATE, getUpdatePayload()));

	// tell others when you want to send an action request
	state.onInternalSendActionRequest(({ payload, target }) => {
		if (Array.isArray(target)) {
			// unicast to targets
			target.forEach(targetUuid => unicast(targetUuid, EVENTS.PERFORM_ACTION, payload));
		} else {
			// broadcast to all
			broadcast(EVENTS.PERFORM_ACTION, payload);
		}
	});

	let disconnected = false;
	const disconnect = () => {
		if (disconnected) {
			return;
		}
		broadcast(EVENTS.DISCONNECTED);
		channel.close();
		disconnected = true;
	};
	window.addEventListener('beforeunload', disconnect);
	return {
		disconnect,
		externalAppClose: sourceId => {
			if (!sourceId) return;
			return removeState({ sourceId });
		},
		sendDirectMessage: opts => {
			if (!opts || typeof opts !== 'object') {
				throw new Error('No message details provided.');
			}
			if (!opts.targetId) throw new Error('targetId not provided in message details');
			if (!opts.data) throw new Error('data not provided in message details');
			return unicast(opts.targetId, EVENTS.DIRECT_MESSAGE, { data: opts.data });
		},
		onDirectMessage: fn => onUnicast(EVENTS.DIRECT_MESSAGE, fn)
	};
};
// CONCATENATED MODULE: ./src/context/debug.js
// xprettier-ignore

let debugLogsEnabled = false;

const enableDebugLogs = api => {
	if (debugLogsEnabled) return;
	debugLogsEnabled = true;

	const log = ({ event, details, data }) => {
		console.groupCollapsed(event);
		const toLog = data ? [details, data] : [details];
		console.log(...toLog);
		console.group('Context Data');
		console.log('scope', api.getScope());
		console.log('sourceId', api.getSourceId());
		console.log('connections', api.getConnected());
		console.log('context', api.getContext());
		console.log('contextAvailable', api.getContext({ debug: true }));
		console.log('appAccepts', api.getOwnAcceptedContextTypes());
		console.log('appProvides', api.getOwnActionTypes());
		console.log('appActions', api.getOwnActionTypes());
		console.log('othersAccept', api.getAcceptedContextTypes());
		console.log('othersProvide', api.getProvidedContextTypes());
		console.log('othersActions', api.getActionTypes());
		console.groupEnd();
		console.groupEnd();
	};

	api.onContextUpdate(() => {
		log({ event: 'Context Data Update', details: 'Context has updated' });
	});
	api.onActionTypesUpdate(() => {
		log({
			event: 'Available Actions Update',
			details: 'The available actions that other apps can perform has changed'
		});
	});
	api.onAcceptedContextTypesUpdate(() => {
		log({
			event: 'Accepted Types Update',
			details: 'The types of context data other apps can accept has changed'
		});
	});
	api.onProvidedContextTypesUpdate(() => {
		log({
			event: 'Provided Types Update',
			details: 'The types of context data that other apps can provide has changed.'
		});
	});
	api.onActionRequested(details => {
		log({
			event: 'Action Reqested',
			details: 'Another app has has requested an action to perform',
			data: details
		});
	});
	api.onConnectionsChange(() => {
		log({
			event: 'Connections Change',
			details: 'The number of apps connected to the context API has changed',
			data: `(${api.getConnected().size} other app${api.getConnected().size === 1 ? '' : 's'})`
		});
	});
	api.onDisconnect(() => {
		log({
			event: 'Disconnected',
			details: 'Disconecteed from context'
		});
	});
};

const insertDebugTable = (api, element) => {
	enableDebugLogs(api);
	const UUID = api.getSourceId();
	const log = (method, ...args) => {
		console.info(`ID ${UUID} -`, method, ...args);
	};
	// inject our CSS styles into the document
	const sheet = function () {
		const style = document.createElement('style');
		style.appendChild(document.createTextNode(''));
		document.head.appendChild(style);
		return style.sheet;
	}();
	sheet.insertRule('.ev-ctx .ctx--head { background: #3e505d78; }');
	sheet.insertRule('.ev-ctx .ctx--split { height: 8px; background: #1d262c9e; }');
	sheet.insertRule('.ev-ctx .ctx--split:hover { background: initial; }');
	sheet.insertRule('.ev-ctx .ctx--info { width: 280px; font-weight: normal; color: rgba(250,250,250,0.5) }');
	sheet.insertRule('.ev-table.ev-ctx td { line-height: 20px;     border-top: 1px solid #1d262c; }');

	// now inject the template
	const template = document.createElement('template');
	const ELEMENT_IDS = {
		CONNECTION_ID: `connection-id-${UUID}`,
		CONNECTIONS: `connections-${UUID}`,
		DISCONNECT: `disconnect-${UUID}`,
		THIS_PROVIDES: `this-provides-${UUID}`,
		THIS_ACCEPTS: `this-accepts-${UUID}`,
		THIS_ACTIONS: `this-actions-${UUID}`,
		OTHER_PROVIDERS: `providers-${UUID}`,
		OTHER_ACCEPTS: `accepts-${UUID}`,
		OTHER_ACTIONS: `actions-${UUID}`,
		THIS_CONTEXT_DATA: `own-context-data-${UUID}`,
		CONTEXT_DATA: `context-data-${UUID}`,
		ACTION_DATA: `request-data-${UUID}`
	};
	template.innerHTML = `
        <section class="ev-section">
            <div class="ev-section__body ml-10 mb-20">
                <table class="ev-table ev-ctx">
                    <tbody>
                        <tr><td colspan="2" class="ctx--head">Connectivty</td><td class="ctx--head">Explanation</td></tr>
                        <tr><td style="width: 200px">ID</td><td><div class="ev-badge ev-badge--amber" id="${ELEMENT_IDS.CONNECTION_ID}"></div></td><td class="ctx--info">ID of this app</td></tr>
                        <tr><td>Connections</td><td><span id="${ELEMENT_IDS.CONNECTIONS}"></span></td><td class="ctx--info">ID of other connected apps</td></tr>

                        <tr><td colspan="3" class="ctx--split"></td></tr>
                        <tr><td colspan="2" class="ctx--head">Context Types</td><td class="ctx--head">Explanation</td></tr>
                        <tr><td>This Provides</td><td><span id="${ELEMENT_IDS.THIS_PROVIDES}"></span></td><td class="ctx--info">Types of context this app can provide to other apps</td></tr>
                        <tr><td>This Accepts</td><td><span id="${ELEMENT_IDS.THIS_ACCEPTS}"></span></td><td class="ctx--info">Types of context this app will accept from other apps</td></tr>
                        <tr><td>Others Provide</td><td><span id="${ELEMENT_IDS.OTHER_PROVIDERS}"></span></td><td class="ctx--info">Types of context other apps can provide</td></tr>
                        <tr><td>Others Accept</td><td><span id="${ELEMENT_IDS.OTHER_ACCEPTS}"></span></td><td class="ctx--info">Types of context other apps will accept</td></tr>

                        <tr><td colspan="3" class="ctx--split"></td></tr>
                        <tr><td colspan="2" class="ctx--head">Action Types</td><td class="ctx--head">Explanation</td></tr>
                        <tr><td>This Performs</td><td><span id="${ELEMENT_IDS.THIS_ACTIONS}"></span></td><td class="ctx--info">Actions that other apps can ask this app to perform</td></tr>
                        <tr><td>Others Perform</td><td><span id="${ELEMENT_IDS.OTHER_ACTIONS}"></span></td><td class="ctx--info">Actions that this app can ask others apps to perform</td></tr>

                        <tr><td colspan="3" class="ctx--split"></td></tr>
                        <tr><td colspan="2" class="ctx--head">Data Payloads</td><td class="ctx--head">Explanation</td></tr>
						<tr><td>Context Sent</td><td><pre id="${ELEMENT_IDS.THIS_CONTEXT_DATA}" style="white-space: pre-line; height: 40px; overflow-y: scroll;"></pre></td><td class="ctx--info">Context data sent to other apps</td></tr>
						<tr><td>Context Received</td><td><pre id="${ELEMENT_IDS.CONTEXT_DATA}" style="white-space: pre-line; height: 40px; overflow-y: scroll;"></pre></td><td class="ctx--info">Context data received from other apps</td></tr>
                        <tr><td>Action Requests</td><td><pre id="${ELEMENT_IDS.ACTION_DATA}" style="white-space: pre-line;"></pre></td><td class="ctx--info">Action requests received from other apps</td></tr>

						<tr><td colspan="3" class="ctx--split"></td></tr>
                        <tr><td colspan="3" class="ctx--head">Lifecycle Testing</td></tr>
                        <tr>
							<td><button type="button" class="ev-button ev-button--small ev-button--secondary mt-10 mb-10" id="${ELEMENT_IDS.DISCONNECT}">Disconnect</button></td>
							<td class="ctx--info" colspan="2" style="text-align: right">Stops the app from sending / receiving context and actions, and inform others of this.</td>
						</tr>
                    </tbody>
                </table>
            </div>
        </section>
    `;
	const $ = (...args) => element.querySelector(...args);
	const table = template.content.cloneNode(true);
	element.insertBefore(table, element.firstChild);

	const mapDisplay = (i, idx) => {
		let sourceIds = '';
		if (i.sourceIds && i.sourceIds.length) {
			sourceIds = i.sourceIds.map(s => `<div class="ev-badge ev-badge--amber ml-5">${s}</div>`).join('');
		}
		return [`${idx !== 0 ? ' ' : ''}`, `<div class="ev-badge ev-badge--blue">${i.type}</div>`, `<div class="ev-badge ev-badge--secondary">v${i.version}</div>`, sourceIds, '<span class="mr-5"></span><br />'].join('');
	};

	const updateOtherAccepts = () => $(`#${ELEMENT_IDS.OTHER_ACCEPTS}`).innerHTML = api.getAcceptedContextTypes().map(mapDisplay).join('');
	const updateThisProvides = () => $(`#${ELEMENT_IDS.THIS_PROVIDES}`).innerHTML = api.getOwnProvidedContextTypes().map(mapDisplay).join('');
	const updateThisAccepts = () => {
		$(`#${ELEMENT_IDS.THIS_ACCEPTS}`).innerHTML = api.getOwnAcceptedContextTypes().map(mapDisplay).join('');
	};
	const updateThisPerformsActions = () => {
		$(`#${ELEMENT_IDS.THIS_ACTIONS}`).innerHTML = api.getOwnActionTypes().map(mapDisplay).join('');
	};
	const updateOtherProviders = () => $(`#${ELEMENT_IDS.OTHER_PROVIDERS}`).innerHTML = api.getProvidedContextTypes().map(mapDisplay).join('');
	const updateOtherActionTypes = () => $(`#${ELEMENT_IDS.OTHER_ACTIONS}`).innerHTML = api.getActionTypes().map(mapDisplay).join('');
	const updateContextData = () => {
		// update own
		$(`#${ELEMENT_IDS.THIS_CONTEXT_DATA}`).innerHTML = api.getOwnContextData().map(i => `${JSON.stringify(i)}\n`);
		// update others
		$(`#${ELEMENT_IDS.CONTEXT_DATA}`).innerHTML = api.getContext().map(i => `${JSON.stringify(i)}\n`);
	};

	const updateConnections = () => {
		const map = api.getConnected();
		let connected = '';
		map.forEach(i => {
			const el = `<div class="ev-badge ev-badge--amber mr-5">${i.sourceId}</div>`;
			connected = connected ? `${connected}${el}` : el;
		});
		$(`#${ELEMENT_IDS.CONNECTIONS}`).innerHTML = connected;
	};

	const refreshTable = () => {
		$(`#${ELEMENT_IDS.CONNECTION_ID}`).innerHTML = api.getSourceId();
		updateThisProvides();
		updateThisAccepts();
		updateThisPerformsActions();
		updateOtherAccepts();
		updateOtherProviders();
		updateOtherActionTypes();
		updateContextData();
		updateConnections();
	};

	refreshTable();

	$(`#${ELEMENT_IDS.DISCONNECT}`).addEventListener('click', e => {
		api.disconnect();
		e.target.disabled = true;
		$('.ev-table').style.opacity = 0.25;
	});
	api.onAcceptedContextTypesUpdate(() => {
		updateThisAccepts();
		updateOtherAccepts();
	});
	api.onProvidedContextTypesUpdate(() => {
		updateThisProvides();
		updateOtherProviders();
	});
	api.onActionTypesUpdate(() => {
		updateThisPerformsActions();
		updateOtherActionTypes();
	});
	api.onContextUpdate(() => {
		updateContextData();
	});
	api.onActionRequested(action => {
		log('action-requested', action);
		$(`#${ELEMENT_IDS.ACTION_DATA}`).innerHTML = `${JSON.stringify(action)}\n`;
	});
	api.onConnectionsChange(updateConnections);
};
// CONCATENATED MODULE: ./src/context/circuit-breaker.js
const LIMIT_PER_SECOND = 100;
const SECOND_IN_MS = 1000;

// exported for unit tests
const getErrorString = api => {
	return ['Context API Circuit Breaker:', 'Evolve Runtime has disconnected this app from the context API to prevent a browser crash.', `The number of context updates has exceeded the limit of ${LIMIT_PER_SECOND} per second.`, 'Its likely that an app has logic that is causing a continous loop', '', 'Context API Information:', `App ID - ${api.getSourceId()}`, `Shared Scope ID - ${api.getScope()}`].join('\n');
};

// keeps track of the context updates and imposes a limit per second
// if the limit is breached, then we automatically disconnect from the
// context API for safety
const monitor = api => {
	let updateCount = 0;
	let timeoutId = null;

	const resetRollingCounts = () => {
		clearTimeout(timeoutId);
		updateCount = 0;
		timeoutId = null;
	};

	api.onContextUpdate(() => {
		updateCount++;
		if (updateCount >= LIMIT_PER_SECOND) {
			api.disconnect();
			throw new Error(getErrorString(api));
		}
		if (!timeoutId) {
			timeoutId = setTimeout(resetRollingCounts, SECOND_IN_MS);
		}
	});
};
// CONCATENATED MODULE: ./src/context/index.js






const context_create = ({
	runtimeId, // the unique id of the current app
	rootInstanceId // the unique id of the current instance of Evolve
}) => {
	if (typeof runtimeId !== 'string') throw new Error('Expected a runtime id to be passed');

	const localConnections = new Map();
	const onContextChannelCreated = fn => {
		return onChannelCreation(fn);
	};

	const connect = ({ scope, id, instanceOnly } = {}) => {
		const uuid = typeof id === 'string' ? id : runtimeId;

		// if the communications are to be scoped to only the current running instance of Evolve, then prefix
		// the channel with the root instance id (this automatically scopes to this instance)
		const instanceScope = instanceOnly ? `${rootInstanceId}/` : '';

		// create the scope of the comms
		const contextScope = typeof scope === 'string' && scope !== '*' ? scope : CHANNELS.PUBLIC;

		// now prefix the scope with the instance id, if we only want this to be specific to the current instance
		const channelName = `${instanceScope}${contextScope}`;

		const key = `${channelName}-${uuid}`;
		if (localConnections.has(key)) return localConnections.get(key);
		const channel = createChannel({ name: channelName, uuid });
		const state = createState(uuid);
		const comms = setupCommunication(channel, uuid, state);
		const api = {
			// context - the data available
			getContext: opts => state.getCollectionContext(opts),
			setContext: state.setContext,
			onContextUpdate: state.onContextUpdate,
			getOwnContextData: state.getSelfContextData,

			// providers - types of data which can be provided to others
			getProvidedContextTypes: () => state.getCollectionProvidedTypes(),
			getOwnProvidedContextTypes: state.getSelfProvidedTypes,
			providesContextType: state.addProvidedContextType,
			onProvidedContextTypesUpdate: state.onProvidedContextTypesUpdate,

			// acceptors - types of data which others accept
			getAcceptedContextTypes: () => state.getCollectionAcceptedTypes(),
			getOwnAcceptedContextTypes: state.getSelfAcceptedTypes,
			acceptsContextType: state.addAcceptedContextType,
			onAcceptedContextTypesUpdate: state.onAcceptedContextTypesUpdate,

			// actions - types of actions which others accept
			getActionTypes: () => state.getCollectionActionTypes(),
			getOwnActionTypes: state.getSelfActionTypes,
			performsActionType: state.addActionType,
			onActionTypesUpdate: state.onActionTypesUpdate,

			// requesting actions
			requestAction: state.requestAction,
			onActionRequested: state.onActionRequested,

			// generic app-to-app messaging
			sendDirectMessage: comms.sendDirectMessage,
			onDirectMessage: comms.onDirectMessage,

			// misc
			getConnected: () => state.getCollection(),
			onConnectionsChange: state.onNumberConnectedChange,
			waitForConnections: state.waitForConnections,
			onDisconnect: state.onUnbind,
			disconnect: () => {
				state.unbindEvents();
				comms.disconnect();
				localConnections.delete(key);
			},
			getSourceId: () => uuid,
			getScope: () => channelName,
			enableDebugLogs: () => enableDebugLogs(api),
			insertDebugTable: el => insertDebugTable(api, el),

			// only used when an app has closed but other (disco bar) informs us of this
			informExternalAppClose: id => {
				const connected = api.getConnected();
				if (!connected.has(id)) return;
				return comms.externalAppClose(id);
			}
		};
		localConnections.set(key, api);

		// monitor the API to prevent abuse or potential crashes from bad logic
		monitor(api);

		return api;
	};
	return {
		connect,
		onContextChannelCreated
	};
};
// CONCATENATED MODULE: ./src/instances/index.js
const SESSION_KEYS = {
	ROOT_INSTANCE_ID: 'evolve.runtime.rootEvolveInstanceId'
};

const instances_get = key => {
	if (window.sessionStorage) {
		return window.sessionStorage.getItem(key);
	}
	return null;
};

const instances_set = (key, val) => {
	if (window.sessionStorage) {
		window.sessionStorage.setItem(key, val);
	}
};

const setupRootInstance = ({ uuid, isRootInstance }) => {
	// this only applies to the root instance (i.e. the discovery bar)
	if (isRootInstance) {
		const createInstanceId = () => {
			const newId = `evolve-discovery-bar-instance-${uuid}`;
			try {
				// try get existing session id
				const id = instances_get(SESSION_KEYS.ROOT_INSTANCE_ID);
				// use the id, if available, otherwise return a new id (as its a new instance)
				return typeof id === 'string' && id.length ? id : newId;
			} catch (e) {
				return newId;
			}
		};

		const id = createInstanceId();

		if (typeof id !== 'string') throw new Error('Expected id to be a string');

		// set the ID onto the window
		window.name = id;

		// finally save the session ID for other runtimes to pickup
		instances_set(SESSION_KEYS.ROOT_INSTANCE_ID, id);
	}

	return instances_get(SESSION_KEYS.ROOT_INSTANCE_ID);
};

const createInstancesApi = runtime => {
	// setup (if necessary) and obtain the root instance id
	const IS_ROOT_INSTANCE = document.location.pathname === '/discovery-bar/';
	const ROOT_INSTANCE_ID = setupRootInstance({
		uuid: runtime.uuid(),
		isRootInstance: IS_ROOT_INSTANCE
	});

	// add the api to the runtime
	runtime.getRootInstanceId = () => ROOT_INSTANCE_ID;

	// now return the ID for others to use
	return {
		rootInstanceId: ROOT_INSTANCE_ID,
		isRootInstance: IS_ROOT_INSTANCE
	};
};
// EXTERNAL MODULE: ./src/communication/public-events-enum.js
var public_events_enum = __webpack_require__(4);

// EXTERNAL MODULE: ./src/context/types.js
var types = __webpack_require__(0);

// EXTERNAL MODULE: ./src/remote-storage/index.js
var remote_storage = __webpack_require__(3);

// EXTERNAL MODULE: ./src/setup-context.js
var setup_context = __webpack_require__(6);

// EXTERNAL MODULE: ./src/runtime/ui/modal.js
var modal = __webpack_require__(1);

// CONCATENATED MODULE: ./src/utils/styles.js


// Evolve Runtime API style
const appendStyles = () => {
	const styleBlock = `
/* local modal box --------------------------------------- */

/* suppress focus on everything else */
body.${modal["a" /* BODY_MODAL_CSS_CLASS */]} button,
body.${modal["a" /* BODY_MODAL_CSS_CLASS */]} a,
body.${modal["a" /* BODY_MODAL_CSS_CLASS */]} area,
body.${modal["a" /* BODY_MODAL_CSS_CLASS */]} textarea,
body.${modal["a" /* BODY_MODAL_CSS_CLASS */]} input,
body.${modal["a" /* BODY_MODAL_CSS_CLASS */]} select,
body.${modal["a" /* BODY_MODAL_CSS_CLASS */]} option {
	visibility: hidden !important;
}

/* continue to allow focus on the modal */
body.${modal["a" /* BODY_MODAL_CSS_CLASS */]} .ev-modal button,
body.${modal["a" /* BODY_MODAL_CSS_CLASS */]} .ev-modal a,
body.${modal["a" /* BODY_MODAL_CSS_CLASS */]} .ev-modal area,
body.${modal["a" /* BODY_MODAL_CSS_CLASS */]} .ev-modal textarea,
body.${modal["a" /* BODY_MODAL_CSS_CLASS */]} .ev-modal input,
body.${modal["a" /* BODY_MODAL_CSS_CLASS */]} .ev-modal select,
body.${modal["a" /* BODY_MODAL_CSS_CLASS */]} .ev-modal option,
body.${modal["a" /* BODY_MODAL_CSS_CLASS */]} .${modal["b" /* SUPPRESS_FOCUS_CSS_CLASS */]} button,
body.${modal["a" /* BODY_MODAL_CSS_CLASS */]} .${modal["b" /* SUPPRESS_FOCUS_CSS_CLASS */]} a,
body.${modal["a" /* BODY_MODAL_CSS_CLASS */]} .${modal["b" /* SUPPRESS_FOCUS_CSS_CLASS */]} area,
body.${modal["a" /* BODY_MODAL_CSS_CLASS */]} .${modal["b" /* SUPPRESS_FOCUS_CSS_CLASS */]} textarea,
body.${modal["a" /* BODY_MODAL_CSS_CLASS */]} .${modal["b" /* SUPPRESS_FOCUS_CSS_CLASS */]} input,
body.${modal["a" /* BODY_MODAL_CSS_CLASS */]} .${modal["b" /* SUPPRESS_FOCUS_CSS_CLASS */]} select,
body.${modal["a" /* BODY_MODAL_CSS_CLASS */]} .${modal["b" /* SUPPRESS_FOCUS_CSS_CLASS */]} option {
	visibility: inherit !important;
}

`;
	const checkStyles = () => {
		try {
			const styleTagID = 'evolve-runtime-style';
			const styleTag = document.querySelector(`#${styleTagID}`);
			const createStyle = () => {
				const addStyleTag = document.createElement('style');
				addStyleTag.id = styleTagID;
				addStyleTag.innerHTML += styleBlock;
				document.getElementsByTagName('head')[0].appendChild(addStyleTag);
			};
			if (!styleTag) createStyle();
		} catch (e) {
			console.error('Could not append Evolve Runtime styles to the body - error to follow');
			console.error(e);
		}
	};
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', checkStyles);
	} else {
		checkStyles();
	}
};
// CONCATENATED MODULE: ./src/index.js










if (typeof global !== 'undefined' && global) {
	global.evolveRuntime = src_runtime;
}
if (typeof window !== 'undefined' && window) {
	window.evolveRuntime = src_runtime;
}

const { rootInstanceId: src_rootInstanceId, isRootInstance } = createInstancesApi(src_runtime);

const { connect: src_connect, onContextChannelCreated: src_onContextChannelCreated } = context_create({
	rootInstanceId: src_rootInstanceId,
	runtimeId: instance.getName()
});

src_runtime.version = "2.24.2"; // PKG_VERSION is defined in webpack config
src_runtime.EVENTS = public_events_enum["a" /* default */];
src_runtime.CONTEXT_TYPES = types["b" /* CONTEXT_TYPES */];
src_runtime.ACTION_TYPES = types["a" /* ACTION_TYPES */];
src_runtime.MESSAGE_TYPES = types["c" /* MESSAGE_TYPES */];
src_runtime.REMOTE_STORAGE_METHODS = remote_storage["a" /* REMOTE_STORAGE_METHODS */];
src_runtime.connect = src_connect;
src_runtime.onContextChannelCreated = src_onContextChannelCreated;

Object(setup_context["a" /* default */])({
	runtime: src_runtime,
	rootInstanceId: src_rootInstanceId,
	isRootInstance
});

// append Evolve Runtime styles
appendStyles();

/* harmony default export */ var src = __webpack_exports__["default"] = (src_runtime);

/***/ }),
/* 8 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 9 */
/***/ (function(module, exports) {

/* eslint-disable */

(function (global) {
  var channels = [];

  function BroadcastChannel(channel) {
    var $this = this;
    channel = String(channel);

    var id = '$BroadcastChannel$' + channel + '$';

    channels[id] = channels[id] || [];
    channels[id].push(this);

    this._name = channel;
    this._id = id;
    this._closed = false;
    this._mc = new MessageChannel();
    this._mc.port1.start();
    this._mc.port2.start();

    global.addEventListener('storage', function (e) {
      if (e.storageArea !== global.localStorage) return;
      if (e.newValue === null) return;
      if (e.key.substring(0, id.length) !== id) return;
      var data = JSON.parse(e.newValue);
      $this._mc.port2.postMessage(data);
    });
  }

  BroadcastChannel.prototype = {
    // BroadcastChannel API
    get name() {
      return this._name;
    },
    postMessage: function (message) {
      var $this = this;
      if (this._closed) {
        var e = new Error();
        e.name = 'InvalidStateError';
        throw e;
      }
      var value = JSON.stringify(message);

      // Broadcast to other contexts via storage events...
      var key = this._id + String(Date.now()) + '$' + String(Math.random());
      global.localStorage.setItem(key, value);
      setTimeout(function () {
        global.localStorage.removeItem(key);
      }, 500);

      // Broadcast to current context via ports
      channels[this._id].forEach(function (bc) {
        if (bc === $this) return;
        bc._mc.port2.postMessage(JSON.parse(value));
      });
    },
    close: function () {
      if (this._closed) return;
      this._closed = true;
      this._mc.port1.close();
      this._mc.port2.close();

      var index = channels[this._id].indexOf(this);
      channels[this._id].splice(index, 1);
    },

    // EventTarget API
    get onmessage() {
      return this._mc.port1.onmessage;
    },
    set onmessage(value) {
      this._mc.port1.onmessage = value;
    },
    addEventListener: function (type, listener /*, useCapture*/) {
      return this._mc.port1.addEventListener.apply(this._mc.port1, arguments);
    },
    removeEventListener: function (type, listener /*, useCapture*/) {
      return this._mc.port1.removeEventListener.apply(this._mc.port1, arguments);
    },
    dispatchEvent: function (event) {
      return this._mc.port1.dispatchEvent.apply(this._mc.port1, arguments);
    }
  };

  global.BroadcastChannel = global.BroadcastChannel || BroadcastChannel;
})(self);

/***/ })
/******/ ]);
});
//# sourceMappingURL=evolve-runtime.js.map